// Supplemental translations for zh (简体中文), ja (日本語), ar (العربية), hi (हिन्दी).
// Merged into T at load time by translations.js. Placeholders like {n} {s} {name} {r} {ring} {email} {v} must be preserved.
export const EXTRA = {
  ko: {
    "login.title": "로그인",
    "login.subtitle": "주최자 영역",
    "common.email": "이메일",
    "common.password": "비밀번호",
    "login.enter": "입장",
    "login.accessing": "로그인 중…",
    "login.noAccount": "계정이 없으신가요?",
    "login.register": "회원가입",
    "login.areYouRing": "링이신가요?",
    "login.ringLogin": "링 로그인",
    "login.identifier": "이메일",
    "register.sentTitle": "이메일을 확인하세요",
    "register.sentMsg": "확인 링크를 다음 주소로 보냈습니다",
    "register.sentHint": "이메일의 링크를 클릭해 계정을 활성화하세요. 스팸함도 확인하세요.",
    "register.resend": "확인 이메일 재전송",
    "register.resent": "이메일을 다시 보냈습니다",
    "register.resendWait": "{s}초 후 다시 시도",
    "verify.verifying": "확인 중…",
    "verify.ok": "계정이 활성화되었습니다! 로그인 중…",
    "verify.invalid": "링크가 유효하지 않거나 만료되었습니다. 다시 가입해 주세요.",
    "hero.l1": "당신의",
    "hero.l2": "태권도",
    "hero.l3": "대회를 관리하세요",
    "hero.sub": "이벤트, 선수, 조, 링, 실시간 스코어보드를 하나의 웹 플랫폼에서.",
    "register.title": "계정 만들기",
    "register.name": "이름",
    "register.cta": "가입하고 100 토큰 받기",
    "register.creating": "생성 중…",
    "register.haveAccount": "이미 계정이 있으신가요?",
    "register.login": "로그인",
    "dash.events": "내 이벤트",
    "dash.eventsSub": "대회를 만들고 관리하세요.",
    "dash.newEvent": "새 이벤트",
    "dash.eventName": "이벤트 이름",
    "dash.type": "유형",
    "dash.date": "날짜",
    "dash.deleteTitle": "이벤트 삭제",
    "dash.deleteWarn": "정말 이 이벤트를 삭제하시겠습니까? 이 작업은 되돌릴 수 없으며 선수, 조, 링, 경기도 함께 삭제됩니다.\n확인하려면 아래에 이벤트 이름을 입력하세요.",
    "dash.clickToCopy": "클릭하여 복사",
    "dash.deleteCta": "영구 삭제",
    "dash.cancel": "취소",
    "ath.edit": "선수 편집",
    "ath.updated": "선수가 업데이트됨",
    "ath.lockedDiscipline": "종목은 이벤트 유형으로 정해집니다.",
    "common.delete": "삭제",
    "dash.create": "이벤트 만들기",
    "dash.empty": "이벤트가 없습니다. 하나 만들어 시작하세요.",
    "dash.token": "토큰",
    "banner.tokensZero": "토큰이 소진되었습니다. 계속하려면 충전하세요.",
    "banner.tokensZeroCta": "충전하려면 여기를 클릭",
    "dash.namePlaceholder": "예: 시티 트로피 2026",
    "dash.confirmDelete": "이 이벤트와 모든 데이터를 삭제하시겠습니까?",
    "dash.deleted": "이벤트가 삭제됨",
    "dash.created": "이벤트가 생성됨",
    "dash.enterName": "이름을 입력하세요",
    "type.combat": "겨루기",
    "type.poomsae": "품새",
    "type.mixed": "혼합",
    "type.poomsaeForms": "품새 (형)",
    "ev.tabAthletes": "선수",
    "ev.tabPools": "조 및 경기",
    "ev.tabRings": "링",
    "ev.tabSettings": "설정",
    "common.loading": "불러오는 중…",
    "ath.title": "선수",
    "ath.templateCsv": "템플릿 다운로드 (CSV)",
    "ath.import": "선수 가져오기 (CSV)",
    "ath.exportCsv": "선수 다운로드 (CSV)",
    "ath.add": "추가",
    "ath.new": "새 선수",
    "ath.firstName": "이름",
    "ath.lastName": "성",
    "ath.birth": "생년월일",
    "ath.weight": "체중 (kg)",
    "ath.belt": "띠",
    "ath.height": "신장 (cm)",
    "ath.disciplines": "종목",
    "ath.save": "선수 저장",
    "ath.colName": "성 이름",
    "ath.colBirth": "생년",
    "ath.colWeight": "체중",
    "ath.colBelt": "띠",
    "ath.colDisc": "종목",
    "ath.empty": "선수가 없습니다. 추가하거나 CSV/Excel에서 가져오세요.",
    "ath.reqNames": "이름과 성은 필수입니다",
    "ath.added": "선수가 추가됨",
    "ath.imported": "{n}명의 선수를 가져왔습니다",
    "pool.title": "조",
    "pool.aiSuggest": "AI로 제안",
    "pool.aiWorking": "AI 처리 중…",
    "pool.autoGen": "자동 생성",
    "pool.autoTitle": "조 자동 생성",
    "pool.autoDesc": "태권도 규정에 따라 연령대, 띠, 체중으로 선수를 묶습니다.",
    "pool.method": "방식",
    "pool.methodLocal": "로컬 (항상 사용 가능)",
    "pool.methodAi": "AI (권장, 네트워크 필요)",
    "pool.minSize": "조당 최소 인원",
    "pool.maxSize": "조당 최대 인원",
    "pool.weightTol": "체중 허용치 (체중의 %)",
    "pool.weightTolShort": "체중 허용 %",
    "pool.ageTolShort": "연령 허용 %",
    "pool.heightTolShort": "신장 허용 %",
    "pool.beltTolShort": "띠 허용 %",
    "pool.mixedPools": "혼성 조 (활성화 시 혼성)",
    "pool.tolHint": "100%는 이 항목을 무시함을 의미합니다.",
    "pool.replace": "기존 조 대체",
    "pool.generate": "조 생성",
    "pool.generating": "생성 중…",
    "pool.autoCreated": "{n}개의 조가 생성됨",
    "pool.aiFallback": "AI 사용 불가: 로컬 엔진 사용 ({n}개 조)",
    "pool.overrideTitle": "조 설정",
    "pool.overrideDesc": "이 조에만 이벤트 설정을 재정의합니다 (예: 어린이용 짧은 라운드).",
    "pool.overrideHint": "변경을 적용하려면 조 경기를 다시 생성하세요.",
    "pool.overrideActive": "사용자 지정",
    "pool.overrideSaved": "조 설정이 저장됨",
    "pool.overrideReset": "이벤트 설정으로 초기화",
    "rc.offline": "오프라인",
    "rc.clearJudges": "심판 제거",
    "rc.clearJudgesConfirm": "이 링의 모든 심판 연결을 해제할까요?",
    "rc.judgesCleared": "심판이 제거됨",
    "rc.resetJudges": "심판 초기화",
    "rc.resetConfirm": "심판 화면을 초기화할까요? 진행 중인 채점이 지워집니다.",
    "rc.judgesReset": "심판 화면이 초기화됨",
    "ath.sex": "성별",
    "ath.female": "여자",
    "ath.male": "남자",
    "ath.noSex": "미지정",
    "pool.renamePrompt": "조 이름 (메모 추가 가능, 예: '조 1, 카데트'):",
    "j.leave": "나가기",
    "j.add": "추가",
    "ring.accessQr": "스테이션 접속",
    "ring.scanStation": "태블릿/휴대폰으로 QR을 스캔해 이 링을 열거나 링크를 복사하세요 (PC에서도 편리).",
    "ring.quickLink": "빠른 링크 복사 (자동 로그인)",
    "ring.secureLink": "보안 링크 복사 (비밀번호 필요)",
    "err.generic": "문제가 발생했습니다. 다시 시도하세요.",
    "err.token_expired": "세션이 만료되었습니다. 다시 로그인하세요.",
    "err.invalid_token": "유효하지 않은 토큰입니다.",
    "err.not_authenticated": "인증되지 않았습니다.",
    "err.user_not_found": "사용자를 찾을 수 없습니다.",
    "err.event_not_found": "이벤트를 찾을 수 없습니다.",
    "err.email_taken": "이미 등록된 이메일입니다.",
    "err.invalid_credentials": "잘못된 자격 증명입니다.",
    "err.ring_password_wrong": "링 비밀번호가 틀렸습니다.",
    "err.ring_not_found": "링을 찾을 수 없습니다.",
    "err.athlete_not_found": "선수를 찾을 수 없습니다.",
    "err.file_read": "파일을 읽을 수 없습니다. 형식을 확인하세요.",
    "err.pool_not_found": "조를 찾을 수 없습니다.",
    "err.tiebreak_only_score": "동점 재경기는 점수제 품새 조에서만 가능합니다.",
    "err.tiebreak_need_two": "동점 재경기에는 최소 2명의 선수가 필요합니다.",
    "err.pool_not_found_event": "이 이벤트에서 조를 찾을 수 없습니다.",
    "err.no_athletes_discipline": "이 종목에 선수가 없습니다.",
    "err.match_not_found": "경기를 찾을 수 없습니다.",
    "err.access_denied": "접근이 거부되었습니다.",
    "err.judges_not_ready": "심판이 준비되지 않았습니다 ({n}).",
    "err.tokens_exhausted": "토큰이 소진되었습니다. 계속하려면 충전하세요.",
    "err.unknown_action": "알 수 없는 작업입니다.",
    "err.invalid_judge_token": "유효하지 않은 심판 토큰입니다.",
    "err.invalid_package": "유효하지 않은 패키지입니다.",
    "err.price_not_found": "가격을 찾을 수 없습니다.",
    "err.transaction_not_found": "거래를 찾을 수 없습니다.",
    "err.invalid_signature": "유효하지 않은 서명입니다.",
    "pool.new": "새 조",
    "pool.unassigned": "미배정",
    "pool.athletes": "{n}명의 선수",
    "pool.allAssigned": "모두 배정됨.",
    "pool.dragHere": "여기에 선수를 끌어다 놓으세요.",
    "pool.genMatches": "경기 생성",
    "pool.matches": "{n}경기",
    "pool.needMore": "선수가 더 필요합니다",
    "pool.aiCreated": "AI: {n}개 조 생성",
    "pool.moveError": "이동 오류",
    "pool.matchesGenerated": "{n}경기가 생성됨",
    "bracket.single_elim": "싱글 엘리미네이션",
    "bracket.round_robin": "라운드 로빈",
    "bracket.group_elim": "조별 + 토너먼트",
    "bracket.score": "점수제",
    "ring.title": "링 및 배정",
    "ring.name": "링 이름",
    "ring.number": "번호",
    "ring.discipline": "종목",
    "ring.create": "링 만들기",
    "ring.created": "링이 생성됨",
    "ring.none": "링이 없습니다. 경기를 배정하려면 하나 만드세요.",
    "ring.assigned": "{n}경기가 배정됨",
    "ring.eventId": "이벤트 ID",
    "ring.ringId": "링 ID",
    "ring.password": "비밀번호",
    "ring.assignPool": "조 배정…",
    "ring.assign": "배정",
    "ring.openStation": "링 열기",
    "ring.selectPool": "조를 선택하세요",
    "ring.genFirst": "먼저 경기를 생성하세요",
    "ring.copied": "복사됨",
    "ring.assignedToast": "{n}경기를 {ring}에 배정했습니다",
    "ring.assignedPools": "배정된 조 (순서대로)",
    "ring.removePool": "링에서 조 제거",
    "ring.printRing": "링 시트 인쇄",
    "ring.poolRemoved": "조가 링에서 제거됨",
    "ring.allPoolsAssigned": "모든 조가 이미 배정됨",
    "filter.both": "겨루기 및 품새",
    "filter.combat": "겨루기",
    "filter.poomsae": "품새",
    "set.title": "이벤트 설정",
    "set.sub": "모든 경기의 기본값; 경기별로도 변경할 수 있습니다.",
    "set.combat": "겨루기",
    "set.rounds": "라운드 수",
    "set.roundDur": "라운드 시간 (s)",
    "set.break": "휴식 (s)",
    "set.koDiff": "기술 KO 점수 차",
    "set.consensusWindow": "합의 시간 (s)",
    "set.consensusHint": "점수를 부여하려면 대다수 심판이 일치해야 하는 시간(초) (0.2–2.0).",
    "set.judges": "심판 수",
    "set.poomsae": "품새",
    "set.forms": "선수당 형 수",
    "set.ringAccess": "링 접속",
    "set.ringPw": "링 비밀번호 (공유)",
    "set.ringPwHint": "링 컴퓨터가 이벤트 연결에 사용합니다.",
    "set.save": "설정 저장",
    "set.saving": "저장 중…",
    "set.saved": "설정이 저장됨",
    "set.tokensTitle": "토큰",
    "set.tokensPoomsae": "품새 평가마다 토큰 1개가 필요합니다.",
    "set.tokensCombat": "겨루기(라운드 수 무관)마다 토큰 2개가 필요합니다.",
    "set.tokensCheck": "이벤트를 진행할 토큰이 충분한지 확인하세요.",
    "set.tokensReload": "토큰 충전",
    "rl.title": "링 로그인",
    "rl.back": "로그인으로 돌아가기",
    "rl.sub": "경기를 관리하려면 링 스테이션으로 로그인하세요.",
    "rl.connect": "링 연결",
    "rl.connecting": "연결 중…",
    "rl.connected": "연결됨: {name}",
    "rc.queue": "대기열",
    "rc.judges": "심판",
    "rc.monitor": "모니터",
    "rc.incontri": "경기",
    "rc.noneAssigned": "배정된 경기가 없습니다.",
    "rc.colJudge": "심판",
    "rc.colTech": "기술 점수",
    "rc.colBalance": "균형",
    "rc.colRhythm": "리듬",
    "rc.colPower": "파워",
    "rc.colTotal": "합계",
    "rc.colAvg": "평균",
    "rc.noVotesYet": "심판 채점 대기 중…",
    "rc.selectMatch": "대기열에서 경기를 선택하세요.",
    "rc.round": "라운드",
    "rc.break": "휴식",
    "rc.start": "시작",
    "rc.pause": "일시정지",
    "rc.reset": "초기화",
    "rc.resetMatch": "초기화",
    "rc.resetMatchConfirm": "재경기할까요? 결과가 지워지고 재시작 시 토큰 2개가 다시 차감됩니다.",
    "rc.resetMatchHint": "재시작하면 토큰 2개가 다시 소모됩니다.",
    "rc.matchReset": "경기가 초기화됨",
    "err.match_locked": "결과가 잠겼습니다: 재경기하려면 초기화를 사용하세요.",
    "rc.roundPlus": "라운드 +",
    "rc.roundExtraHint": "연장 라운드는 예정된 라운드 종료 시 동점일 때만 가능합니다.",
    "err.round_not_tied": "연장 라운드는 동점일 때만 허용됩니다.",
    "rc.medical": "메디컬 타임",
    "rc.soundOn": "소리 켜짐 (라운드 및 휴식 종료)",
    "rc.soundOff": "소리 꺼짐",
    "rc.waitingJudges": "심판 준비 대기 중 ({r}/{n})",
    "rc.winner": "승자: {name}",
    "rc.performing": "연기 중",
    "rc.tie": "동점",
    "rc.tieHint": "평균 점수 동일: 동점 재경기를 고려하세요.",
    "mon.performing": "연기 중",
    "res.reshuffle": "재추첨",
    "pool.drawPreview": "경기 미리보기",
    "pool.downloadPdf": "PDF 다운로드",
    "common.pdf": "PDF",
    "pool.execOrder": "연기 순서",
    "pool.bye": "(부전승)",
    "res.reshuffleConfirm": "새 무작위 대진으로 추첨을 다시 생성할까요?",
    "res.reshuffled": "새 추첨 완료",
    "res.swapHint": "위치를 바꾸려면 1라운드의 두 선수를 클릭하세요.",
    "res.tiebreak": "동점 재경기",
    "res.tiebreakBtn": "동점 재경기 생성",
    "res.tiebreakRegen": "동점 재경기 재생성",
    "res.tiebreakCreated": "동점 재경기 생성됨: 링에서 진행하세요",
    "res.tiebreakPending": "동점 재경기 진행 중",
    "rc.winnerDecreed": "승자가 선언됨",
    "rc.point": "점",
    "rc.wins": "승",
    "rc.warnLight": "경고(경):",
    "rc.warnSevere": "경고(중):",
    "rc.judgesQr": "QR로 심판 추가",
    "rc.ready": "준비됨",
    "rc.noJudges": "연결된 심판이 없습니다.",
    "rc.requireReady": "심판 준비 필수",
    "rc.startPerf": "연기 시작",
    "rc.waitingReady": "심판 준비 대기 중",
    "rc.startConsumes": "시작하면 토큰 1개가 소모되고 심판 채점이 열립니다.",
    "rc.form": "품새",
    "rc.avgAuto": "모든 심판이 현재 형을 제출하면 심판 평균이 자동 계산됩니다.",
    "rc.avgTotal": "총 평균",
    "rc.confirmPerf": "확정 및 연기 종료",
    "rc.confirmPerformance": "연기 확정",
    "rc.perfConfirmed": "연기가 확정됨",
    "rc.cancelPerformance": "연기 취소",
    "rc.cancelPerfConfirm": "연기를 취소할까요? 점수가 초기화되고 심판이 다시 채점합니다.",
    "rc.removeJudge": "심판 제거",
    "rc.removeJudgeConfirm": "이 심판을 링에서 제거할까요?",
    "rc.judgeRemoved": "심판이 제거됨",
    "j.access": "심판 로그인",
    "j.yourName": "이름",
    "j.ready": "준비됨",
    "j.waitingMatch": "링이 경기를 선택하기를 기다리는 중…",
    "j.assignPoints": "채점 — 휴대폰을 가로로 잡으세요",
    "j.technical": "기술 점수",
    "j.form": "품새",
    "j.errLight": "경미한 실수",
    "j.errSevere": "심각한 실수",
    "j.energy": "파워",
    "j.balance": "균형",
    "j.rhythm": "리듬",
    "j.total": "합계",
    "j.send": "채점 전송",
    "j.readyFirst": "먼저 준비 상태를 확인하세요",
    "j.sent": "전송됨",
    "j.voteSent": "채점 전송됨: {v}",
    "mon.waiting": "경기 대기 중",
    "mon.warnLight": "경경고",
    "mon.warnSevere": "중경고",
    "mon.round": "라운드",
    "mon.break": "휴식",
    "mon.medical": "메디컬",
    "mon.winner": "승자",
    "mon.form": "품새",
    "mon.avg": "평균",
    "bill.title": "토큰 충전",
    "bill.sub": "겨루기 경기당 토큰 2개, 품새 연기당 토큰 1개.",
    "bill.custom": "사용자 지정 수량",
    "bill.token": "토큰",
    "bill.perToken": "/ 토큰",
    "bill.buy": "구매",
    "bill.redirecting": "이동 중…",
    "bill.checkoutTitle": "결제 완료",
    "bill.checkoutSub": "토큰 · €",
    "bill.loading": "결제 불러오는 중…",
    "bill.best": "최고의 가치",
    "bill.secure": "Stripe를 통한 안전한 결제.",
    "bill.secureLive": "Stripe와 PayPal을 통한 안전한 결제.",
    "bill.orPaypal": "또는 PayPal로 결제",
    "bill.paypalSuccess": "PayPal 결제 완료, 토큰이 적립되었습니다!",
    "bill.paypalError": "PayPal 결제 실패. 다시 시도하세요.",
    "pay.checking": "결제 확인 중…",
    "pay.success": "결제 성공",
    "pay.added": "계정에 토큰 {n}개가 추가되었습니다.",
    "pay.backDash": "대시보드로 돌아가기",
    "pay.pending": "결제 처리 중. 토큰이 곧 표시됩니다.",
    "pay.dashboard": "대시보드",
    "pay.error": "문제가 발생했습니다",
    "pay.retry": "다시 시도",
    "pay.cancelled": "결제가 취소됨",
    "pay.backPackages": "패키지로 돌아가기",
    "ev.tabResults": "결과",
    "res.champion": "챔피언",
    "res.title": "결과",
    "res.export": "결과 다운로드",
    "res.exportTitle": "대회 결과",
    "res.standings": "순위",
    "res.wins": "승",
    "res.noData": "생성된 경기가 없습니다. 조에서 생성하세요.",
    "res.round": "라운드",
    "res.pending": "대기 중",
    "res.avg": "평균",
    "res.tbd": "미정",
    "res.bye": "부전승",
    "admin.link": "KIHAP 관리자",
    "admin.back": "대시보드로 돌아가기",
    "admin.createTitle": "계정 만들기",
    "admin.email": "이메일",
    "admin.name": "이름",
    "admin.tokens": "토큰",
    "admin.password": "비밀번호",
    "admin.pwManual": "비밀번호 수동 설정",
    "admin.pwAutoHint": "자동 생성",
    "admin.create": "계정 만들기",
    "admin.created": "계정이 생성됨",
    "admin.genPw": "생성된 비밀번호 (지금 복사하세요):",
    "admin.copy": "복사",
    "admin.copied": "복사됨",
    "admin.usersTitle": "사용자",
    "admin.search": "이메일 또는 이름으로 검색",
    "admin.role": "역할",
    "admin.balance": "토큰",
    "admin.save": "저장",
    "admin.updated": "토큰이 업데이트됨",
    "admin.delete": "계정 삭제",
    "admin.deleted": "계정이 삭제됨",
    "admin.confirmDelete": "계정 {email}을(를) 영구 삭제할까요?",
    "err.cannot_delete_admin": "관리자 계정은 삭제할 수 없습니다",
    "admin.noUsers": "사용자가 없습니다",
    "admin.error": "작업 실패",
    "acct.title": "설정",
    "acct.account": "내 계정",
    "acct.username": "사용자 이름",
    "acct.usernameHint": "가입 시 선택한 이름: 앱 전체에 표시됩니다.",
    "acct.email": "이메일",
    "acct.tokenCredit": "토큰 잔액",
    "acct.editName": "사용자 이름 편집",
    "acct.nameSaved": "이름이 업데이트됨",
    "err.name_taken": "이미 사용 중인 사용자 이름입니다.",
    "err.name_required": "사용자 이름을 입력하세요.",
    "acct.pwEncrypted": "비밀번호는 암호화되어 보안상 표시할 수 없습니다. 아래에서 변경할 수 있습니다.",
    "acct.changePw": "비밀번호 변경",
    "acct.oldPw": "현재 비밀번호",
    "acct.newPw": "새 비밀번호",
    "acct.confirmPw": "새 비밀번호 확인",
    "acct.pwMismatch": "비밀번호가 일치하지 않습니다.",
    "acct.pwChanged": "비밀번호가 업데이트됨",
    "acct.recovery": "복구 이메일",
    "acct.recoveryHint": "접근 복구에 사용: 사용자 이름과 비밀번호 재설정 링크를 받게 됩니다.",
    "acct.recoveryEmail": "복구 이메일",
    "acct.recoveryEdit": "복구 이메일 편집",
    "acct.recoverySaved": "복구 이메일이 저장됨",
    "acct.antiPhish": "피싱 방지 코드",
    "acct.antiPhishHint": "모든 KIHAP 이메일에 포함된 코드: 없으면 피싱입니다.",
    "acct.antiPhishEdit": "피싱 방지 코드 편집",
    "acct.antiPhishSaved": "피싱 방지 코드가 저장됨",
    "acct.movements": "토큰 내역",
    "acct.noMovements": "아직 구매 내역이 없습니다",
    "acct.date": "날짜",
    "acct.tokens": "토큰",
    "acct.amount": "금액",
    "acct.method": "방식",
    "acct.dangerZone": "위험 구역",
    "acct.deleteAccount": "계정 삭제",
    "acct.deleteWarnShort": "삭제하면 생성한 모든 이벤트, 선수 정보, 구매한 토큰이 영구적으로 사라집니다.",
    "acct.deleteTitle": "계정 삭제",
    "acct.deleteWarn": "삭제하면 생성한 모든 이벤트, 선수 정보, 구매한 토큰이 영구적으로 사라집니다. 계정을 영구 삭제하려면 아래에 계정 이름을 입력하고 확인하세요.",
    "acct.deleteCta": "영구 삭제",
    "acct.deleteSuccess": "계정이 삭제됨",
    "acct.deleteAdminNote": "관리자 계정은 삭제할 수 없습니다.",
    "acct.error": "작업 실패",
    "rpw.title": "비밀번호 재설정",
    "rpw.submit": "재설정",
    "rpw.done": "비밀번호가 재설정되었습니다. 이제 로그인할 수 있습니다.",
    "rpw.invalid": "링크가 유효하지 않거나 만료되었습니다.",
    "login.forgot": "비밀번호를 잊으셨나요?",
    "login.forgotPrompt": "복구 이메일을 입력하세요 (설정에서 지정한 것):",
    "login.forgotSent": "복구 이메일이 존재하면 안내를 보냈습니다.",
    "err.old_password_wrong": "현재 비밀번호가 틀렸습니다",
    "err.password_short": "비밀번호는 6자 이상이어야 합니다",
    "err.reset_invalid": "재설정 링크가 유효하지 않거나 만료됨",
    "err.email_failed": "이메일 전송 실패",
    "err.admin_only": "관리자 전용",
    "err.email_required": "유효한 이메일이 필요합니다",
    "err.no_change": "변경 없음",
    "csv.firstName": "이름", "csv.lastName": "성", "csv.birth": "생년월일", "csv.weight": "체중", "csv.belt": "띠", "csv.school": "TKD 도장", "csv.height": "신장", "csv.sex": "성별", "csv.compType": "경기 유형",
    "dash.duration": "기간 (일)", "dash.days": "일", "status.programmato": "예정됨", "status.in_corso": "진행 중", "status.concluso": "종료됨", "status.non_svolto": "미개최",
    "set.tokensOwner": "토큰은 이벤트 소유자의 잔액에서만 차감됩니다.", "collab.title": "협업자 관리", "collab.desc": "소유자만 역할을 지정하거나 삭제할 수 있습니다.", "collab.roleOwner": "소유자", "collab.roleCo": "공동 주최자", "collab.roleReg": "등록 담당자", "collab.roleObs": "관찰자", "collab.email": "협업자의 KIHAP 이메일", "collab.add": "초대 생성", "collab.linkCreated": "초대 링크가 생성·복사되었습니다 — 협업자에게 보내세요.", "collab.none": "협업자가 없습니다.", "collab.confirmRemoveTitle": "협업자를 삭제할까요?", "collab.confirmRemoveDesc": "{name} 님은 즉시 이벤트 접근 권한을 잃게 됩니다. 대기 중인 초대 링크는 무효화됩니다. 나중에 다시 초대할 수 있습니다.", "collab.confirmRemoveBtn": "삭제", "forgot.title": "접근 복구", "forgot.desc": "계정에 연결된 이메일 주소를 입력하시면 계정에 접속할 수 있는 이메일을 보내드립니다.", "forgot.cta": "복구 링크 보내기", "forgot.back": "로그인으로 돌아가기", "forgot.sentTitle": "이메일을 확인하세요", "forgot.sentMsg": "이 주소로 등록된 계정이 있으면 로그인용 이메일을 보냈습니다:", "club.title": "클럽 순위", "club.desc": "클럽 순위 방식을 선택하세요.", "club.method": "순위 방식", "club.methodMedals": "금메달 수 기준 (올림픽 방식)", "club.methodPoints": "점수 기준", "club.goldPts": "금메달당 점수", "club.silverPts": "은메달당 점수", "club.bronzePts": "동메달당 점수", "club.doubleBronze": "더블 브론즈", "club.doubleBronzeHint": "켜면 3위와 4위 모두에게 동메달을 부여합니다(둘 다 메달 집계에 포함).", "ev.tabOffline": "오프라인 모드", "off.title": "오프라인 / LAN 모드", "off.desc": "PC에서 실행할 KIHAP Server Tournament를 다운로드하세요. 심판과 링은 라우터의 로컬 WiFi로 연결하며 인터넷이 필요 없습니다.", "off.estimate": "이 이벤트의 예상 토큰", "off.breakdown": "겨루기 {combat}경기 × 2 토큰 + 품새 평가 {poomsae}건", "off.tiebreak": "이벤트 중 동점 상황을 처리하기 위해 추가 평가가 필요할 수 있습니다. 이러한 경우를 위해 여분의 토큰 15개를 확보하세요.", "off.balance": "현재 잔액", "off.deductNote": "서버를 다운로드하면 잔액에서 토큰 {n}개가 차감되어 이 이벤트 패키지에 로드됩니다.", "off.aiOff": "로컬 LAN 모드에서는 AI 기능이 비활성화됩니다.", "off.download": "KIHAP Server Tournament 다운로드", "off.downloading": "패키지 준비 중...", "off.ready": "다운로드가 시작되었습니다.", "off.notEnough": "서버를 다운로드할 토큰이 부족합니다.", "off.ownerOnly": "이벤트 소유자만 서버를 다운로드할 수 있습니다.", "offtok.warn": "주의: 토큰 {n}개 남음", "offtok.low": "토큰이 {n}개만 남았습니다!", "offtok.emptyTitle": "토큰 소진", "offtok.emptyMsg": "평가가 일시 중지되었습니다. 계속하려면 PC를 인터넷에 연결하고 토큰을 추가 구매한 뒤 이벤트 서버를 다시 다운로드하세요.", "offtok.dismiss": "계속 둘러보기", "offtok.suspended": "토큰 소진 — 새 평가가 중지됨", "srv.scan": "연결하려면 스캔하세요", "srv.judgesScan": "심판: 담당 링을 스캔하세요", "srv.offlineOnly": "이 페이지는 오프라인(LAN) 모드에서만 사용할 수 있습니다.", "srv.noRings": "구성된 링이 없습니다", "res.clubs": "클럽", "clubres.club": "클럽", "clubres.athletes": "선수", "clubres.gold": "금", "clubres.silver": "은", "clubres.bronze": "동", "clubres.points": "점수", "clubres.rank": "순위", "clubres.noClub": "클럽 없음", "invite.title": "협업 초대", "invite.accept": "초대 수락", "invite.wrongEmail": "이 초대는 다른 이메일 계정용입니다. 초대된 이메일로 로그인하세요.", "invite.accepted": "초대를 수락했습니다!", "err.invite_wrong_email": "이 초대는 다른 이메일 계정용입니다.",
    "rc.koTitle": "기술 KO",
    "rc.koMsg": "점수 차에 도달했습니다. {name}을(를) 기술 KO 승자로 선언할까요?",
    "rc.koConfirm": "KO 확정",
    "rc.koContinue": "경기 계속",
  },
  zh: {
    "login.title": "登录",
    "login.subtitle": "组织者专区",
    "common.email": "电子邮箱",
    "common.password": "密码",
    "login.enter": "进入",
    "login.accessing": "正在登录…",
    "login.noAccount": "还没有账户？",
    "login.register": "注册",
    "login.areYouRing": "你是赛台吗？",
    "login.ringLogin": "赛台登录",
    "login.identifier": "电子邮箱",
    "register.sentTitle": "请查收邮件",
    "register.sentMsg": "我们已将确认链接发送至",
    "register.sentHint": "请点击邮件中的链接激活账户，也请检查垃圾邮件。",
    "register.resend": "重新发送确认邮件",
    "register.resent": "邮件已重新发送",
    "register.resendWait": "{s}秒后重试",
    "verify.verifying": "正在验证…",
    "verify.ok": "账户已激活！正在登录…",
    "verify.invalid": "链接无效或已过期，请重新注册。",
    "hero.l1": "管理你的",
    "hero.l2": "跆拳道",
    "hero.l3": "比赛",
    "hero.sub": "赛事、运动员、分组、赛台和实时记分板，尽在一个网页平台。",
    "register.title": "创建账户",
    "register.name": "姓名",
    "register.cta": "注册即得 100 代币",
    "register.creating": "正在创建…",
    "register.haveAccount": "已有账户？",
    "register.login": "登录",
    "dash.events": "你的赛事",
    "dash.eventsSub": "创建并管理你的比赛。",
    "dash.newEvent": "新建赛事",
    "dash.eventName": "赛事名称",
    "dash.type": "类型",
    "dash.date": "日期",
    "dash.deleteTitle": "删除赛事",
    "dash.deleteWarn": "确定要删除该赛事吗？此操作不可撤销，并将同时移除运动员、分组、赛台和对阵。\n请在下方输入赛事名称以确认。",
    "dash.clickToCopy": "点击复制",
    "dash.deleteCta": "永久删除",
    "dash.cancel": "取消",
    "ath.edit": "编辑运动员",
    "ath.updated": "运动员已更新",
    "ath.lockedDiscipline": "项目由赛事类型决定。",
    "common.delete": "删除",
    "dash.create": "创建赛事",
    "dash.empty": "暂无赛事。创建一个开始吧。",
    "dash.token": "代币",
    "banner.tokensZero": "代币已用完，请充值以继续。",
    "banner.tokensZeroCta": "点击此处充值",
    "dash.namePlaceholder": "例如 城市杯 2026",
    "dash.confirmDelete": "删除此赛事及其所有数据？",
    "dash.deleted": "赛事已删除",
    "dash.created": "赛事已创建",
    "dash.enterName": "请输入名称",
    "type.combat": "Kyorugi",
    "type.poomsae": "品势",
    "type.mixed": "混合",
    "type.poomsaeForms": "品势（套路）",
    "ev.tabAthletes": "运动员",
    "ev.tabPools": "分组与对阵",
    "ev.tabRings": "赛台",
    "ev.tabSettings": "设置",
    "common.loading": "加载中…",
    "ath.title": "运动员",
    "ath.templateCsv": "下载模板（CSV）",
    "ath.import": "导入运动员（CSV）",
    "ath.exportCsv": "下载运动员（CSV）",
    "ath.add": "添加",
    "ath.new": "新运动员",
    "ath.firstName": "名",
    "ath.lastName": "姓",
    "ath.birth": "出生日期",
    "ath.weight": "体重（公斤）",
    "ath.belt": "腰带",
    "ath.height": "身高（厘米）",
    "ath.disciplines": "参赛项目",
    "ath.save": "保存运动员",
    "ath.colName": "姓 名",
    "ath.colBirth": "出生",
    "ath.colWeight": "体重",
    "ath.colBelt": "腰带",
    "ath.colDisc": "项目",
    "ath.empty": "暂无运动员。手动添加或从 CSV/Excel 导入。",
    "ath.reqNames": "姓和名为必填",
    "ath.added": "运动员已添加",
    "ath.imported": "已导入 {n} 名运动员",
    "pool.title": "分组",
    "pool.aiSuggest": "用 AI 建议",
    "pool.aiWorking": "AI 处理中…",
    "pool.autoGen": "自动生成",
    "pool.autoTitle": "自动生成分组",
    "pool.autoDesc": "按跆拳道规则根据年龄段、腰带和体重对运动员分组。",
    "pool.method": "方式",
    "pool.methodLocal": "本地（始终可用）",
    "pool.methodAi": "AI（推荐，需要联网）",
    "pool.minSize": "每组最少人数",
    "pool.maxSize": "每组最多人数",
    "pool.weightTol": "体重容差（占体重百分比）",
    "pool.weightTolShort": "体重容差 %",
    "pool.ageTolShort": "年龄容差 %",
    "pool.heightTolShort": "身高容差 %",
    "pool.beltTolShort": "腰带容差 %",
    "pool.mixedPools": "混合分组（启用则混合）",
    "pool.tolHint": "100% 表示忽略此参数。",
    "pool.replace": "替换现有分组",
    "pool.generate": "生成分组",
    "pool.generating": "生成中…",
    "pool.autoCreated": "已生成 {n} 个分组",
    "pool.aiFallback": "AI 不可用：已使用本地引擎（{n} 个分组）",
    "pool.overrideTitle": "分组设置",
    "pool.overrideDesc": "仅为该分组覆盖赛事设置（例如儿童使用更短的回合）。",
    "pool.overrideHint": "重新生成该分组的对阵以应用更改。",
    "pool.overrideActive": "自定义",
    "pool.overrideSaved": "分组设置已保存",
    "pool.overrideReset": "重置为赛事设置",
    "rc.offline": "离线",
    "rc.clearJudges": "移除裁判",
    "rc.clearJudgesConfirm": "解除该赛台的所有裁判？",
    "rc.judgesCleared": "裁判已移除",
    "rc.resetJudges": "重置裁判",
    "rc.resetConfirm": "重置裁判界面？他们进行中的评分将被清除。",
    "rc.judgesReset": "裁判界面已重置",
    "ath.sex": "性别",
    "ath.female": "女",
    "ath.male": "男",
    "ath.noSex": "未指定",
    "pool.renamePrompt": "分组名称（可添加备注，例如“第1组，少年组”）：",
    "j.leave": "离开",
    "j.add": "添加",
    "ring.accessQr": "工位访问",
    "ring.scanStation": "用平板/手机扫描二维码打开此赛台，或复制链接（在电脑上也方便）。",
    "ring.quickLink": "复制快捷链接（自动登录）",
    "ring.secureLink": "复制安全链接（需要密码）",
    "err.generic": "出错了，请重试。",
    "err.token_expired": "会话已过期，请重新登录。",
    "err.invalid_token": "令牌无效。",
    "err.not_authenticated": "未认证。",
    "err.user_not_found": "未找到用户。",
    "err.event_not_found": "未找到赛事。",
    "err.email_taken": "该邮箱已注册。",
    "err.invalid_credentials": "凭据无效。",
    "err.ring_password_wrong": "赛台密码错误。",
    "err.ring_not_found": "未找到赛台。",
    "err.athlete_not_found": "未找到运动员。",
    "err.file_read": "无法读取文件，请检查格式。",
    "err.pool_not_found": "未找到分组。",
    "err.tiebreak_only_score": "加时赛仅适用于计分制品势分组。",
    "err.tiebreak_need_two": "加时赛至少需要两名运动员。",
    "err.pool_not_found_event": "此赛事中未找到分组。",
    "err.no_athletes_discipline": "此项目没有运动员。",
    "err.match_not_found": "未找到对阵。",
    "err.access_denied": "拒绝访问。",
    "err.judges_not_ready": "裁判未就绪（{n}）。",
    "err.tokens_exhausted": "代币已用完，请充值以继续。",
    "err.unknown_action": "未知操作。",
    "err.invalid_judge_token": "裁判令牌无效。",
    "err.invalid_package": "套餐无效。",
    "err.price_not_found": "未找到价格。",
    "err.transaction_not_found": "未找到交易。",
    "err.invalid_signature": "签名无效。",
    "pool.new": "新分组",
    "pool.unassigned": "未分配",
    "pool.athletes": "{n} 名运动员",
    "pool.allAssigned": "已全部分配。",
    "pool.dragHere": "将运动员拖到此处。",
    "pool.genMatches": "生成对阵",
    "pool.matches": "{n} 场对阵",
    "pool.needMore": "需要更多运动员",
    "pool.aiCreated": "AI：已创建 {n} 个分组",
    "pool.moveError": "移动出错",
    "pool.matchesGenerated": "已生成 {n} 场对阵",
    "bracket.single_elim": "单败淘汰",
    "bracket.round_robin": "循环赛",
    "bracket.group_elim": "小组赛 + 淘汰",
    "bracket.score": "计分制",
    "ring.title": "赛台与分配",
    "ring.name": "赛台名称",
    "ring.number": "编号",
    "ring.discipline": "项目",
    "ring.create": "创建赛台",
    "ring.created": "赛台已创建",
    "ring.none": "暂无赛台。创建一个以分配对阵。",
    "ring.assigned": "已分配 {n} 场对阵",
    "ring.eventId": "赛事 ID",
    "ring.ringId": "赛台 ID",
    "ring.password": "密码",
    "ring.assignPool": "分配分组…",
    "ring.assign": "分配",
    "ring.openStation": "打开赛台",
    "ring.selectPool": "选择一个分组",
    "ring.genFirst": "请先生成对阵",
    "ring.copied": "已复制",
    "ring.assignedToast": "已将 {n} 场对阵分配给 {ring}",
    "ring.assignedPools": "已分配的分组（按顺序）",
    "ring.removePool": "从赛台移除分组",
    "ring.printRing": "打印赛台表",
    "ring.poolRemoved": "分组已从赛台移除",
    "ring.allPoolsAssigned": "所有分组均已分配",
    "filter.both": "Kyorugi与品势",
    "filter.combat": "Kyorugi",
    "filter.poomsae": "品势",
    "set.title": "赛事设置",
    "set.sub": "所有对阵的默认值；你也可以按每场对阵单独修改。",
    "set.combat": "Kyorugi",
    "set.rounds": "回合数",
    "set.roundDur": "回合时长（s）",
    "set.break": "休息（s）",
    "set.koDiff": "技术性KO分差",
    "set.consensusWindow": "共识窗口（s）",
    "set.consensusHint": "在此秒数内多数裁判须一致才计分（0.2–2.0）。",
    "set.judges": "裁判人数",
    "set.poomsae": "品势",
    "set.forms": "每位运动员的套路数",
    "set.ringAccess": "赛台访问",
    "set.ringPw": "赛台密码（共享）",
    "set.ringPwHint": "赛台电脑用它连接到赛事。",
    "set.save": "保存设置",
    "set.saving": "保存中…",
    "set.saved": "设置已保存",
    "set.tokensTitle": "代币",
    "set.tokensPoomsae": "每次品势评分消耗一个代币。",
    "set.tokensCombat": "每场 Kyorugi 比赛（无论回合数）消耗两个代币。",
    "set.tokensCheck": "请确认你有足够代币来运行赛事。",
    "set.tokensReload": "充值代币",
    "rl.title": "赛台登录",
    "rl.back": "返回登录",
    "rl.sub": "以赛台工位身份登录以管理对阵。",
    "rl.connect": "连接赛台",
    "rl.connecting": "连接中…",
    "rl.connected": "已连接：{name}",
    "rc.queue": "队列",
    "rc.judges": "裁判",
    "rc.monitor": "监视器",
    "rc.incontri": "对阵",
    "rc.noneAssigned": "未分配对阵。",
    "rc.colJudge": "裁判",
    "rc.colTech": "技术评分",
    "rc.colBalance": "平衡",
    "rc.colRhythm": "节奏",
    "rc.colPower": "力量",
    "rc.colTotal": "总",
    "rc.colAvg": "平均",
    "rc.noVotesYet": "等待裁判评分…",
    "rc.selectMatch": "请从队列中选择一场对阵。",
    "rc.round": "回合",
    "rc.break": "休息",
    "rc.start": "开始",
    "rc.pause": "暂停",
    "rc.reset": "重置",
    "rc.resetMatch": "重置",
    "rc.resetMatchConfirm": "重赛？结果将被清除，重新开始时将再次扣除 2 个代币。",
    "rc.resetMatchHint": "重新开始将再次消耗 2 个代币。",
    "rc.matchReset": "对阵已重置",
    "err.match_locked": "结果已锁定：使用“重置”以重赛。",
    "rc.roundPlus": "加回合",
    "rc.roundExtraHint": "仅当预定回合结束时打平才可加时。",
    "err.round_not_tied": "仅在比分打平时允许加时回合。",
    "rc.medical": "医疗暂停",
    "rc.soundOn": "声音开启（回合与休息结束）",
    "rc.soundOff": "声音关闭",
    "rc.waitingJudges": "等待裁判就绪（{r}/{n}）",
    "rc.winner": "胜者：{name}",
    "rc.performing": "正在进行",
    "rc.tie": "平局",
    "rc.tieHint": "平均分相同：可考虑加时赛。",
    "rc.koTitle": "技术性KO",
    "rc.koMsg": "已达到分差。宣布 {name} 因技术性KO获胜？",
    "rc.koConfirm": "确认KO",
    "rc.koContinue": "继续比赛",
    "mon.performing": "进行中",
    "res.reshuffle": "重新抽签",
    "pool.drawPreview": "对阵预览",
    "pool.downloadPdf": "下载 PDF",
    "common.pdf": "PDF",
    "pool.execOrder": "出场顺序",
    "pool.bye": "（轮空）",
    "res.reshuffleConfirm": "用新的随机配对重新生成抽签？",
    "res.reshuffled": "新抽签完成",
    "res.swapHint": "点击第一轮的两名运动员以交换位置。",
    "res.tiebreak": "加时赛",
    "res.tiebreakBtn": "创建加时赛",
    "res.tiebreakRegen": "重新生成加时赛",
    "res.tiebreakCreated": "加时赛已创建：请到赛台进行",
    "res.tiebreakPending": "加时赛进行中",
    "rc.winnerDecreed": "胜者已宣布",
    "rc.point": "分",
    "rc.wins": "获胜",
    "rc.warnLight": "轻微警告：",
    "rc.warnSevere": "严重警告：",
    "rc.judgesQr": "通过二维码添加裁判",
    "rc.ready": "就绪",
    "rc.noJudges": "无裁判连接。",
    "rc.requireReady": "要求裁判就绪",
    "rc.startPerf": "开始表演",
    "rc.waitingReady": "等待裁判就绪",
    "rc.startConsumes": "开始将消耗 1 个代币并解锁裁判评分。",
    "rc.form": "品势",
    "rc.avgAuto": "当所有裁判都提交当前套路评分后，裁判平均分将自动计算。",
    "rc.avgTotal": "总平均",
    "rc.confirmPerf": "确认并结束表演",
    "rc.confirmPerformance": "确认表演",
    "rc.perfConfirmed": "表演已确认",
    "rc.cancelPerformance": "取消表演",
    "rc.cancelPerfConfirm": "取消该表演？分数将被重置，裁判需重新评分。",
    "rc.removeJudge": "移除裁判",
    "rc.removeJudgeConfirm": "将该裁判移出赛台？",
    "rc.judgeRemoved": "裁判已移除",
    "j.access": "裁判登录",
    "j.yourName": "你的姓名",
    "j.ready": "就绪",
    "j.waitingMatch": "等待赛台选择对阵…",
    "j.assignPoints": "评分 — 请横持手机",
    "j.technical": "技术评分",
    "j.form": "品势",
    "j.errLight": "轻微失误",
    "j.errSevere": "严重失误",
    "j.energy": "力度",
    "j.balance": "平衡",
    "j.rhythm": "节奏",
    "j.total": "总分",
    "j.send": "提交评分",
    "j.readyFirst": "请先确认你已就绪",
    "j.sent": "已提交",
    "j.voteSent": "评分已提交：{v}",
    "mon.waiting": "等待对阵",
    "mon.warnLight": "轻微警告",
    "mon.warnSevere": "严重警告",
    "mon.round": "回合",
    "mon.break": "休息",
    "mon.medical": "医疗",
    "mon.winner": "胜者",
    "mon.form": "品势",
    "mon.avg": "平均",
    "bill.title": "充值代币",
    "bill.sub": "每场 Kyorugi 比赛 2 个代币，每次品势表演 1 个代币。",
    "bill.custom": "自定义数量",
    "bill.token": "代币",
    "bill.perToken": "/ 代币",
    "bill.buy": "购买",
    "bill.redirecting": "跳转中…",
    "bill.checkoutTitle": "完成支付",
    "bill.checkoutSub": "代币 · €",
    "bill.loading": "正在加载支付…",
    "bill.best": "最超值",
    "bill.secure": "通过 Stripe 安全支付。",
    "bill.secureLive": "通过 Stripe 与 PayPal 安全支付。",
    "bill.orPaypal": "或使用 PayPal 支付",
    "bill.paypalSuccess": "PayPal 支付完成，代币已到账！",
    "bill.paypalError": "PayPal 支付失败，请重试。",
    "pay.checking": "正在确认支付…",
    "pay.success": "支付成功",
    "pay.added": "已向你的账户添加 {n} 个代币。",
    "pay.backDash": "返回仪表盘",
    "pay.pending": "支付处理中，代币稍后显示。",
    "pay.dashboard": "仪表盘",
    "pay.error": "出错了",
    "pay.retry": "重试",
    "pay.cancelled": "支付已取消",
    "pay.backPackages": "返回套餐",
    "ev.tabResults": "结果",
    "res.champion": "冠军",
    "res.title": "结果",
    "res.export": "下载结果",
    "res.exportTitle": "赛事结果",
    "res.standings": "排名",
    "res.wins": "胜场",
    "res.noData": "尚未生成对阵。前往“分组”生成。",
    "res.round": "轮次",
    "res.pending": "待定",
    "res.avg": "平均",
    "res.tbd": "待定",
    "res.bye": "轮空",
    "admin.link": "KIHAP 管理",
    "admin.back": "返回仪表盘",
    "admin.createTitle": "创建账户",
    "admin.email": "电子邮箱",
    "admin.name": "姓名",
    "admin.tokens": "代币",
    "admin.password": "密码",
    "admin.pwManual": "手动设置密码",
    "admin.pwAutoHint": "自动生成",
    "admin.create": "创建账户",
    "admin.created": "账户已创建",
    "admin.genPw": "已生成密码（请立即复制）：",
    "admin.copy": "复制",
    "admin.copied": "已复制",
    "admin.usersTitle": "用户",
    "admin.search": "按邮箱或姓名搜索",
    "admin.role": "角色",
    "admin.balance": "代币",
    "admin.save": "保存",
    "admin.updated": "代币已更新",
    "admin.delete": "删除账户",
    "admin.deleted": "账户已删除",
    "admin.confirmDelete": "永久删除账户 {email}？",
    "err.cannot_delete_admin": "无法删除管理员账户",
    "admin.noUsers": "无用户",
    "admin.error": "操作失败",
    "acct.title": "设置",
    "acct.account": "你的账户",
    "acct.username": "用户名",
    "acct.usernameHint": "注册时选择的名称：会显示在整个应用中。",
    "acct.email": "电子邮箱",
    "acct.tokenCredit": "代币余额",
    "acct.editName": "编辑用户名",
    "acct.nameSaved": "名称已更新",
    "err.name_taken": "用户名已被使用。",
    "err.name_required": "请输入用户名。",
    "acct.pwEncrypted": "密码已加密，出于安全无法显示。你可以在下方修改。",
    "acct.changePw": "修改密码",
    "acct.oldPw": "当前密码",
    "acct.newPw": "新密码",
    "acct.confirmPw": "确认新密码",
    "acct.pwMismatch": "两次密码不一致。",
    "acct.pwChanged": "密码已更新",
    "acct.recovery": "找回邮箱",
    "acct.recoveryHint": "用于找回访问：你将收到用户名和重置密码的链接。",
    "acct.recoveryEmail": "找回邮箱",
    "acct.recoveryEdit": "编辑找回邮箱",
    "acct.recoverySaved": "找回邮箱已保存",
    "acct.antiPhish": "反钓鱼码",
    "acct.antiPhishHint": "每封 KIHAP 邮件都会包含此码：若邮件中没有，即为钓鱼。",
    "acct.antiPhishEdit": "编辑反钓鱼码",
    "acct.antiPhishSaved": "反钓鱼码已保存",
    "acct.movements": "代币记录",
    "acct.noMovements": "暂无购买记录",
    "acct.date": "日期",
    "acct.tokens": "代币",
    "acct.amount": "金额",
    "acct.method": "方式",
    "acct.dangerZone": "危险区",
    "acct.deleteAccount": "删除账户",
    "acct.deleteWarnShort": "删除将永久失去你创建的所有赛事、运动员信息以及已购买的代币。",
    "acct.deleteTitle": "删除账户",
    "acct.deleteWarn": "删除将永久失去你创建的所有赛事、运动员信息以及已购买的代币。要永久删除账户，请在下方输入你的账户名称并确认。",
    "acct.deleteCta": "永久删除",
    "acct.deleteSuccess": "账户已删除",
    "acct.deleteAdminNote": "管理员账户无法删除。",
    "acct.error": "操作失败",
    "rpw.title": "重置密码",
    "rpw.submit": "重置",
    "rpw.done": "密码已重置，现在可以登录。",
    "rpw.invalid": "链接无效或已过期。",
    "login.forgot": "忘记密码？",
    "login.forgotPrompt": "请输入你的找回邮箱（在设置中设定的那个）：",
    "login.forgotSent": "如存在找回邮箱，我们已发送说明。",
    "err.old_password_wrong": "当前密码错误",
    "err.password_short": "密码至少需 6 个字符",
    "err.reset_invalid": "重置链接无效或已过期",
    "err.email_failed": "邮件发送失败",
    "err.admin_only": "仅限管理员",
    "err.email_required": "需要有效邮箱",
    "err.no_change": "无更改",
    "csv.firstName": "名字", "csv.lastName": "姓氏", "csv.birth": "出生日期", "csv.weight": "体重", "csv.belt": "腰带", "csv.school": "TKD 道场", "csv.height": "身高", "csv.sex": "性别", "csv.compType": "比赛类型",
    "dash.duration": "持续时间（天）", "dash.days": "天", "status.programmato": "已排期", "status.in_corso": "进行中", "status.concluso": "已结束", "status.non_svolto": "未举办",
    "set.tokensOwner": "代币仅从活动所有者的余额中扣除。", "collab.title": "协作者管理", "collab.desc": "只有所有者可以分配或移除角色。", "collab.roleOwner": "所有者", "collab.roleCo": "联合组织者", "collab.roleReg": "报名管理员", "collab.roleObs": "观察者", "collab.email": "协作者的 KIHAP 邮箱", "collab.add": "生成邀请", "collab.linkCreated": "邀请链接已生成并复制——请发送给协作者。", "collab.none": "暂无协作者。", "collab.confirmRemoveTitle": "移除协作者？", "collab.confirmRemoveDesc": "{name} 将立即失去对该活动的访问权限。任何待处理的邀请链接都将失效。稍后可以再次邀请。", "collab.confirmRemoveBtn": "移除", "forgot.title": "找回访问权限", "forgot.desc": "输入与您账户关联的电子邮箱，我们将向您发送一封用于登录账户的邮件。", "forgot.cta": "发送恢复链接", "forgot.back": "返回登录", "forgot.sentTitle": "请查收邮件", "forgot.sentMsg": "如果存在使用此邮箱的账户，我们已向您发送登录邮件：", "club.title": "俱乐部排名", "club.desc": "选择俱乐部的排名方式。", "club.method": "排名方式", "club.methodMedals": "按金牌数（奥运方式）", "club.methodPoints": "按积分", "club.goldPts": "每金牌积分", "club.silverPts": "每银牌积分", "club.bronzePts": "每铜牌积分", "club.doubleBronze": "双铜牌", "club.doubleBronzeHint": "开启后，第三名和第四名均获得铜牌（两者都计入奖牌榜）。", "ev.tabOffline": "离线模式", "off.title": "离线 / 局域网模式", "off.desc": "下载 KIHAP Server Tournament 在你的电脑上运行。裁判和赛台通过路由器的本地 WiFi 连接，无需互联网。", "off.estimate": "本次赛事预计所需代币", "off.breakdown": "{combat} 场对打 × 2 代币 + {poomsae} 次品势评分", "off.tiebreak": "赛事期间可能需要额外评分来处理平局。请确保有 15 个额外代币以应对此类情况。", "off.balance": "你的当前余额", "off.deductNote": "下载服务器时，将从你的余额中扣除 {n} 个代币并载入本次赛事的安装包。", "off.aiOff": "在本地局域网模式下，AI 功能被禁用。", "off.download": "下载 KIHAP Server Tournament", "off.downloading": "正在准备安装包...", "off.ready": "下载已开始。", "off.notEnough": "代币不足，无法下载服务器。", "off.ownerOnly": "只有赛事所有者才能下载服务器。", "offtok.warn": "注意：剩余 {n} 个代币", "offtok.low": "仅剩 {n} 个代币！", "offtok.emptyTitle": "代币已用尽", "offtok.emptyMsg": "评分已暂停。若要继续，请将电脑连接到互联网，购买更多代币并重新下载赛事服务器。", "offtok.dismiss": "继续浏览", "offtok.suspended": "代币已用尽 — 新评分已暂停", "srv.scan": "扫码连接", "srv.judgesScan": "裁判：扫描你的赛台", "srv.offlineOnly": "此页面仅在离线（局域网）模式下可用。", "srv.noRings": "未配置赛台", "res.clubs": "俱乐部", "clubres.club": "俱乐部", "clubres.athletes": "运动员", "clubres.gold": "金牌", "clubres.silver": "银牌", "clubres.bronze": "铜牌", "clubres.points": "积分", "clubres.rank": "排名", "clubres.noClub": "无俱乐部", "invite.title": "协作邀请", "invite.accept": "接受邀请", "invite.wrongEmail": "此邀请针对其他邮箱账户。请使用受邀邮箱登录。", "invite.accepted": "已接受邀请！", "err.invite_wrong_email": "此邀请针对其他邮箱账户。",
  },
  ja: {
    "login.title": "ログイン",
    "login.subtitle": "主催者エリア",
    "common.email": "メール",
    "common.password": "パスワード",
    "login.enter": "入る",
    "login.accessing": "ログイン中…",
    "login.noAccount": "アカウントがありませんか？",
    "login.register": "登録",
    "login.areYouRing": "リンクですか？",
    "login.ringLogin": "リングログイン",
    "login.identifier": "メール",
    "register.sentTitle": "メールをご確認ください",
    "register.sentMsg": "確認リンクを送信しました：",
    "register.sentHint": "メール内のリンクをクリックしてアカウントを有効化してください。迷惑メールもご確認ください。",
    "register.resend": "確認メールを再送",
    "register.resent": "メールを再送しました",
    "register.resendWait": "{s}秒後に再試行",
    "verify.verifying": "確認中…",
    "verify.ok": "アカウントが有効になりました！ログインします…",
    "verify.invalid": "リンクが無効か期限切れです。もう一度登録してください。",
    "hero.l1": "あなたの",
    "hero.l2": "テコンドー",
    "hero.l3": "大会を管理",
    "hero.sub": "イベント、選手、プール、リング、ライブスコアボードを一つのWebプラットフォームで。",
    "register.title": "アカウント作成",
    "register.name": "名前",
    "register.cta": "登録して100トークンを取得",
    "register.creating": "作成中…",
    "register.haveAccount": "すでにアカウントをお持ちですか？",
    "register.login": "ログイン",
    "dash.events": "あなたのイベント",
    "dash.eventsSub": "あなたの大会を作成・管理しましょう。",
    "dash.newEvent": "新規イベント",
    "dash.eventName": "イベント名",
    "dash.type": "種類",
    "dash.date": "日付",
    "dash.deleteTitle": "イベントを削除",
    "dash.deleteWarn": "本当にこのイベントを削除しますか？この操作は取り消せず、選手・プール・リング・試合も削除されます。\n確認するには下欄にイベント名を入力してください。",
    "dash.clickToCopy": "クリックしてコピー",
    "dash.deleteCta": "完全に削除",
    "dash.cancel": "キャンセル",
    "ath.edit": "選手を編集",
    "ath.updated": "選手を更新しました",
    "ath.lockedDiscipline": "種目はイベント種類で設定されます。",
    "common.delete": "削除",
    "dash.create": "イベントを作成",
    "dash.empty": "イベントがありません。作成して始めましょう。",
    "dash.token": "トークン",
    "banner.tokensZero": "トークンがありません。続けるにはチャージしてください。",
    "banner.tokensZeroCta": "こちらをクリックしてチャージ",
    "dash.namePlaceholder": "例）シティトロフィー2026",
    "dash.confirmDelete": "このイベントとすべてのデータを削除しますか？",
    "dash.deleted": "イベントを削除しました",
    "dash.created": "イベントを作成しました",
    "dash.enterName": "名前を入力してください",
    "type.combat": "Kyorugi",
    "type.poomsae": "プムセ",
    "type.mixed": "混合",
    "type.poomsaeForms": "プムセ（型）",
    "ev.tabAthletes": "選手",
    "ev.tabPools": "プールと試合",
    "ev.tabRings": "リング",
    "ev.tabSettings": "設定",
    "common.loading": "読み込み中…",
    "ath.title": "選手",
    "ath.templateCsv": "テンプレートをダウンロード（CSV）",
    "ath.import": "選手をインポート（CSV）",
    "ath.exportCsv": "選手をダウンロード（CSV）",
    "ath.add": "追加",
    "ath.new": "新しい選手",
    "ath.firstName": "名",
    "ath.lastName": "姓",
    "ath.birth": "生年月日",
    "ath.weight": "体重（kg）",
    "ath.belt": "帯",
    "ath.height": "身長（cm）",
    "ath.disciplines": "種目",
    "ath.save": "選手を保存",
    "ath.colName": "姓 名",
    "ath.colBirth": "生年",
    "ath.colWeight": "体重",
    "ath.colBelt": "帯",
    "ath.colDisc": "種目",
    "ath.empty": "選手がいません。追加するかCSV/Excelからインポートしてください。",
    "ath.reqNames": "姓と名は必須です",
    "ath.added": "選手を追加しました",
    "ath.imported": "{n}名の選手をインポートしました",
    "pool.title": "プール",
    "pool.aiSuggest": "AIで提案",
    "pool.aiWorking": "AI処理中…",
    "pool.autoGen": "自動生成",
    "pool.autoTitle": "プールを自動生成",
    "pool.autoDesc": "テコンドーのルールに従い、年齢区分・帯・体重で選手をグループ化します。",
    "pool.method": "方法",
    "pool.methodLocal": "ローカル（常に利用可能）",
    "pool.methodAi": "AI（推奨、ネット接続が必要）",
    "pool.minSize": "プールの最少人数",
    "pool.maxSize": "プールの最多人数",
    "pool.weightTol": "体重許容差（体重の％）",
    "pool.weightTolShort": "体重許容差 %",
    "pool.ageTolShort": "年齢許容差 %",
    "pool.heightTolShort": "身長許容差 %",
    "pool.beltTolShort": "帯許容差 %",
    "pool.mixedPools": "混合プール（有効なら混合）",
    "pool.tolHint": "100%はこのパラメータを無視することを意味します。",
    "pool.replace": "既存のプールを置き換える",
    "pool.generate": "プールを生成",
    "pool.generating": "生成中…",
    "pool.autoCreated": "{n}個のプールを生成しました",
    "pool.aiFallback": "AI利用不可：ローカルエンジンを使用（{n}個のプール）",
    "pool.overrideTitle": "プール設定",
    "pool.overrideDesc": "このプールのみイベント設定を上書きします（例：子ども向けに短いラウンド）。",
    "pool.overrideHint": "変更を反映するにはプールの試合を再生成してください。",
    "pool.overrideActive": "カスタム",
    "pool.overrideSaved": "プール設定を保存しました",
    "pool.overrideReset": "イベント設定に戻す",
    "rc.offline": "オフライン",
    "rc.clearJudges": "審判を外す",
    "rc.clearJudgesConfirm": "このリングからすべての審判を切断しますか？",
    "rc.judgesCleared": "審判を外しました",
    "rc.resetJudges": "審判をリセット",
    "rc.resetConfirm": "審判画面をリセットしますか？進行中の採点は消去されます。",
    "rc.judgesReset": "審判画面をリセットしました",
    "ath.sex": "性別",
    "ath.female": "女子",
    "ath.male": "男子",
    "ath.noSex": "未指定",
    "pool.renamePrompt": "プール名（メモ追加可、例：「プール1、カデット」）：",
    "j.leave": "退出",
    "j.add": "追加",
    "ring.accessQr": "ステーションアクセス",
    "ring.scanStation": "タブレット/スマホでQRを読み取ってこのリングを開くか、リンクをコピー（PCでも便利）。",
    "ring.quickLink": "クイックリンクをコピー（自動ログイン）",
    "ring.secureLink": "セキュアリンクをコピー（パスワード必要）",
    "err.generic": "問題が発生しました。もう一度お試しください。",
    "err.token_expired": "セッションが切れました。再度ログインしてください。",
    "err.invalid_token": "無効なトークンです。",
    "err.not_authenticated": "認証されていません。",
    "err.user_not_found": "ユーザーが見つかりません。",
    "err.event_not_found": "イベントが見つかりません。",
    "err.email_taken": "このメールは既に登録済みです。",
    "err.invalid_credentials": "認証情報が無効です。",
    "err.ring_password_wrong": "リングのパスワードが違います。",
    "err.ring_not_found": "リングが見つかりません。",
    "err.athlete_not_found": "選手が見つかりません。",
    "err.file_read": "ファイルを読み込めません。形式を確認してください。",
    "err.pool_not_found": "プールが見つかりません。",
    "err.tiebreak_only_score": "タイブレークは得点制プムセのプールのみ利用可能です。",
    "err.tiebreak_need_two": "タイブレークには最低2名の選手が必要です。",
    "err.pool_not_found_event": "このイベントにプールが見つかりません。",
    "err.no_athletes_discipline": "この種目に選手がいません。",
    "err.match_not_found": "試合が見つかりません。",
    "err.access_denied": "アクセスが拒否されました。",
    "err.judges_not_ready": "審判の準備ができていません（{n}）。",
    "err.tokens_exhausted": "トークンがありません。続けるにはチャージしてください。",
    "err.unknown_action": "不明な操作です。",
    "err.invalid_judge_token": "審判トークンが無効です。",
    "err.invalid_package": "無効なパッケージです。",
    "err.price_not_found": "価格が見つかりません。",
    "err.transaction_not_found": "取引が見つかりません。",
    "err.invalid_signature": "署名が無効です。",
    "pool.new": "新規プール",
    "pool.unassigned": "未割り当て",
    "pool.athletes": "{n}名の選手",
    "pool.allAssigned": "すべて割り当て済み。",
    "pool.dragHere": "ここに選手をドラッグ。",
    "pool.genMatches": "試合を生成",
    "pool.matches": "{n}試合",
    "pool.needMore": "選手が足りません",
    "pool.aiCreated": "AI：{n}個のプールを作成",
    "pool.moveError": "移動エラー",
    "pool.matchesGenerated": "{n}試合を生成しました",
    "bracket.single_elim": "シングルエリミネーション",
    "bracket.round_robin": "総当たり",
    "bracket.group_elim": "グループ + トーナメント",
    "bracket.score": "得点制",
    "ring.title": "リングと割り当て",
    "ring.name": "リング名",
    "ring.number": "番号",
    "ring.discipline": "種目",
    "ring.create": "リングを作成",
    "ring.created": "リングを作成しました",
    "ring.none": "リングがありません。作成して試合を割り当ててください。",
    "ring.assigned": "{n}試合を割り当て",
    "ring.eventId": "イベントID",
    "ring.ringId": "リングID",
    "ring.password": "パスワード",
    "ring.assignPool": "プールを割り当て…",
    "ring.assign": "割り当て",
    "ring.openStation": "リングを開く",
    "ring.selectPool": "プールを選択",
    "ring.genFirst": "先に試合を生成してください",
    "ring.copied": "コピーしました",
    "ring.assignedToast": "{n}試合を{ring}に割り当てました",
    "ring.assignedPools": "割り当て済みプール（順番）",
    "ring.removePool": "リングからプールを外す",
    "ring.printRing": "リング表を印刷",
    "ring.poolRemoved": "プールをリングから外しました",
    "ring.allPoolsAssigned": "すべてのプールが割り当て済みです",
    "filter.both": "Kyorugiとプムセ",
    "filter.combat": "Kyorugi",
    "filter.poomsae": "プムセ",
    "set.title": "イベント設定",
    "set.sub": "すべての試合の既定値。試合ごとに変更もできます。",
    "set.combat": "Kyorugi",
    "set.rounds": "ラウンド数",
    "set.roundDur": "ラウンド時間（s）",
    "set.break": "休憩（s）",
    "set.koDiff": "テクニカルKOの点差",
    "set.consensusWindow": "合意ウィンドウ（s）",
    "set.consensusHint": "得点を認めるために過半数の審判が一致すべき秒数（0.2–2.0）。",
    "set.judges": "審判数",
    "set.poomsae": "プムセ",
    "set.forms": "選手あたりの型数",
    "set.ringAccess": "リングアクセス",
    "set.ringPw": "リングパスワード（共有）",
    "set.ringPwHint": "リングのPCがイベント接続に使用します。",
    "set.save": "設定を保存",
    "set.saving": "保存中…",
    "set.saved": "設定を保存しました",
    "set.tokensTitle": "トークン",
    "set.tokensPoomsae": "プムセの採点ごとに1トークンが必要です。",
    "set.tokensCombat": "Kyorugi 1試合（ラウンド数に関係なく）ごとに2トークンが必要です。",
    "set.tokensCheck": "イベント運営に十分なトークンがあるか確認してください。",
    "set.tokensReload": "トークンをチャージ",
    "rl.title": "リングログイン",
    "rl.back": "ログインに戻る",
    "rl.sub": "リングステーションとしてログインして試合を管理します。",
    "rl.connect": "リングに接続",
    "rl.connecting": "接続中…",
    "rl.connected": "接続済み：{name}",
    "rc.queue": "キュー",
    "rc.judges": "審判",
    "rc.monitor": "モニター",
    "rc.incontri": "試合",
    "rc.noneAssigned": "割り当てられた試合がありません。",
    "rc.colJudge": "審判",
    "rc.colTech": "技術点",
    "rc.colBalance": "バランス",
    "rc.colRhythm": "リズム",
    "rc.colPower": "パワー",
    "rc.colTotal": "計",
    "rc.colAvg": "平均",
    "rc.noVotesYet": "審判の採点を待っています…",
    "rc.selectMatch": "キューから試合を選択してください。",
    "rc.round": "ラウンド",
    "rc.break": "休憩",
    "rc.start": "開始",
    "rc.pause": "一時停止",
    "rc.reset": "リセット",
    "rc.resetMatch": "リセット",
    "rc.resetMatchConfirm": "再試合しますか？結果は消去され、再開時に再度2トークンが消費されます。",
    "rc.resetMatchHint": "再開すると再度2トークンを消費します。",
    "rc.matchReset": "試合をリセットしました",
    "err.match_locked": "結果はロック済み：再試合するにはリセットを使用してください。",
    "rc.roundPlus": "ラウンド+",
    "rc.roundExtraHint": "予定ラウンド終了時に同点の場合のみ延長可能です。",
    "err.round_not_tied": "延長ラウンドは同点時のみ許可されます。",
    "rc.medical": "メディカルタイム",
    "rc.soundOn": "音オン（ラウンド・休憩終了）",
    "rc.soundOff": "音オフ",
    "rc.waitingJudges": "審判の準備待ち（{r}/{n}）",
    "rc.winner": "勝者：{name}",
    "rc.performing": "演技中",
    "rc.tie": "同点",
    "rc.tieHint": "平均点が同じ：タイブレークを検討。",
    "rc.koTitle": "テクニカルKO",
    "rc.koMsg": "点差に達しました。{name} をテクニカルKOで勝者にしますか？",
    "rc.koConfirm": "KOを確定",
    "rc.koContinue": "試合を続行",
    "mon.performing": "演技中",
    "res.reshuffle": "再抽選",
    "pool.drawPreview": "試合プレビュー",
    "pool.downloadPdf": "PDFをダウンロード",
    "common.pdf": "PDF",
    "pool.execOrder": "演技順",
    "pool.bye": "（不戦勝）",
    "res.reshuffleConfirm": "新しいランダム組み合わせで抽選をやり直しますか？",
    "res.reshuffled": "新しい抽選完了",
    "res.swapHint": "1回戦の2選手をクリックして位置を入れ替えます。",
    "res.tiebreak": "タイブレーク",
    "res.tiebreakBtn": "タイブレークを作成",
    "res.tiebreakRegen": "タイブレークを再生成",
    "res.tiebreakCreated": "タイブレーク作成：リングで実施してください",
    "res.tiebreakPending": "タイブレーク進行中",
    "rc.winnerDecreed": "勝者を宣言しました",
    "rc.point": "点",
    "rc.wins": "勝利",
    "rc.warnLight": "軽微な警告：",
    "rc.warnSevere": "重い警告：",
    "rc.judgesQr": "QRで審判を追加",
    "rc.ready": "準備完了",
    "rc.noJudges": "接続中の審判がいません。",
    "rc.requireReady": "審判の準備完了を必須にする",
    "rc.startPerf": "演技を開始",
    "rc.waitingReady": "審判の準備を待っています",
    "rc.startConsumes": "開始すると1トークンを消費し、審判の採点が解除されます。",
    "rc.form": "プムセ",
    "rc.avgAuto": "全審判が現在の型を提出すると、審判平均が自動計算されます。",
    "rc.avgTotal": "総平均",
    "rc.confirmPerf": "確定して演技を終了",
    "rc.confirmPerformance": "演技を確定",
    "rc.perfConfirmed": "演技を確定しました",
    "rc.cancelPerformance": "演技を取消",
    "rc.cancelPerfConfirm": "演技を取り消しますか？点数はリセットされ、審判は再度採点します。",
    "rc.removeJudge": "審判を外す",
    "rc.removeJudgeConfirm": "この審判をリングから外しますか？",
    "rc.judgeRemoved": "審判を外しました",
    "j.access": "審判ログイン",
    "j.yourName": "あなたの名前",
    "j.ready": "準備完了",
    "j.waitingMatch": "リングが試合を選ぶのを待っています…",
    "j.assignPoints": "採点 — スマホを横向きに",
    "j.technical": "技術点",
    "j.form": "プムセ",
    "j.errLight": "軽微な失敗",
    "j.errSevere": "重大な失敗",
    "j.energy": "エネルギー",
    "j.balance": "バランス",
    "j.rhythm": "リズム",
    "j.total": "合計",
    "j.send": "採点を送信",
    "j.readyFirst": "まず準備完了を確認してください",
    "j.sent": "送信済み",
    "j.voteSent": "採点を送信：{v}",
    "mon.waiting": "試合を待っています",
    "mon.warnLight": "軽微警告",
    "mon.warnSevere": "重警告",
    "mon.round": "ラウンド",
    "mon.break": "休憩",
    "mon.medical": "メディカル",
    "mon.winner": "勝者",
    "mon.form": "プムセ",
    "mon.avg": "平均",
    "bill.title": "トークンをチャージ",
    "bill.sub": "Kyorugi 1試合につき2トークン、プムセ1演技につき1トークン。",
    "bill.custom": "カスタム数量",
    "bill.token": "トークン",
    "bill.perToken": "/ トークン",
    "bill.buy": "購入",
    "bill.redirecting": "リダイレクト中…",
    "bill.checkoutTitle": "支払いを完了",
    "bill.checkoutSub": "トークン · €",
    "bill.loading": "支払いを読み込み中…",
    "bill.best": "お得",
    "bill.secure": "Stripeによる安全な支払い。",
    "bill.secureLive": "StripeとPayPalによる安全な支払い。",
    "bill.orPaypal": "またはPayPalで支払う",
    "bill.paypalSuccess": "PayPal支払い完了、トークンが付与されました！",
    "bill.paypalError": "PayPal支払いに失敗しました。もう一度お試しください。",
    "pay.checking": "支払いを確認中…",
    "pay.success": "支払い成功",
    "pay.added": "アカウントに{n}トークンを追加しました。",
    "pay.backDash": "ダッシュボードに戻る",
    "pay.pending": "支払い処理中。トークンはまもなく反映されます。",
    "pay.dashboard": "ダッシュボード",
    "pay.error": "問題が発生しました",
    "pay.retry": "再試行",
    "pay.cancelled": "支払いをキャンセルしました",
    "pay.backPackages": "パッケージに戻る",
    "ev.tabResults": "結果",
    "res.champion": "優勝者",
    "res.title": "結果",
    "res.export": "結果をダウンロード",
    "res.exportTitle": "大会結果",
    "res.standings": "順位",
    "res.wins": "勝利数",
    "res.noData": "試合が生成されていません。「プール」で生成してください。",
    "res.round": "ラウンド",
    "res.pending": "保留中",
    "res.avg": "平均",
    "res.tbd": "未定",
    "res.bye": "不戦勝",
    "admin.link": "KIHAP 管理",
    "admin.back": "ダッシュボードに戻る",
    "admin.createTitle": "アカウント作成",
    "admin.email": "メール",
    "admin.name": "名前",
    "admin.tokens": "トークン",
    "admin.password": "パスワード",
    "admin.pwManual": "パスワードを手動設定",
    "admin.pwAutoHint": "自動生成",
    "admin.create": "アカウント作成",
    "admin.created": "アカウントを作成しました",
    "admin.genPw": "生成されたパスワード（今コピーしてください）：",
    "admin.copy": "コピー",
    "admin.copied": "コピーしました",
    "admin.usersTitle": "ユーザー",
    "admin.search": "メールまたは名前で検索",
    "admin.role": "役割",
    "admin.balance": "トークン",
    "admin.save": "保存",
    "admin.updated": "トークンを更新しました",
    "admin.delete": "アカウントを削除",
    "admin.deleted": "アカウントを削除しました",
    "admin.confirmDelete": "アカウント{email}を完全に削除しますか？",
    "err.cannot_delete_admin": "管理者アカウントは削除できません",
    "admin.noUsers": "ユーザーがいません",
    "admin.error": "操作に失敗しました",
    "acct.title": "設定",
    "acct.account": "あなたのアカウント",
    "acct.username": "ユーザー名",
    "acct.usernameHint": "登録時に選んだ名前：アプリ全体で表示されます。",
    "acct.email": "メール",
    "acct.tokenCredit": "トークン残高",
    "acct.editName": "ユーザー名を編集",
    "acct.nameSaved": "名前を更新しました",
    "err.name_taken": "そのユーザー名は既に使用されています。",
    "err.name_required": "ユーザー名を入力してください。",
    "acct.pwEncrypted": "パスワードは暗号化されており、安全のため表示できません。下で変更できます。",
    "acct.changePw": "パスワードを変更",
    "acct.oldPw": "現在のパスワード",
    "acct.newPw": "新しいパスワード",
    "acct.confirmPw": "新しいパスワードを確認",
    "acct.pwMismatch": "パスワードが一致しません。",
    "acct.pwChanged": "パスワードを更新しました",
    "acct.recovery": "復旧用メール",
    "acct.recoveryHint": "アクセス復旧に使用：ユーザー名とパスワード再設定リンクが届きます。",
    "acct.recoveryEmail": "復旧用メール",
    "acct.recoveryEdit": "復旧用メールを編集",
    "acct.recoverySaved": "復旧用メールを保存しました",
    "acct.antiPhish": "フィッシング対策コード",
    "acct.antiPhishHint": "すべてのKIHAPメールに含まれるコード：無ければフィッシングです。",
    "acct.antiPhishEdit": "フィッシング対策コードを編集",
    "acct.antiPhishSaved": "フィッシング対策コードを保存しました",
    "acct.movements": "トークン履歴",
    "acct.noMovements": "まだ購入がありません",
    "acct.date": "日付",
    "acct.tokens": "トークン",
    "acct.amount": "金額",
    "acct.method": "方法",
    "acct.dangerZone": "危険ゾーン",
    "acct.deleteAccount": "アカウントを削除",
    "acct.deleteWarnShort": "削除すると、作成したすべてのイベント、選手情報、購入済みトークンが永久に失われます。",
    "acct.deleteTitle": "アカウント削除",
    "acct.deleteWarn": "削除すると、作成したすべてのイベント、選手情報、購入済みトークンが永久に失われます。完全に削除するには、下欄にアカウント名を入力して確認してください。",
    "acct.deleteCta": "完全に削除",
    "acct.deleteSuccess": "アカウントを削除しました",
    "acct.deleteAdminNote": "管理者アカウントは削除できません。",
    "acct.error": "操作に失敗しました",
    "rpw.title": "パスワードを再設定",
    "rpw.submit": "再設定",
    "rpw.done": "パスワードを再設定しました。ログインできます。",
    "rpw.invalid": "リンクが無効か期限切れです。",
    "login.forgot": "パスワードをお忘れですか？",
    "login.forgotPrompt": "復旧用メールを入力してください（設定で登録したもの）：",
    "login.forgotSent": "復旧用メールが存在すれば、手順を送信しました。",
    "err.old_password_wrong": "現在のパスワードが違います",
    "err.password_short": "パスワードは6文字以上必要です",
    "err.reset_invalid": "再設定リンクが無効か期限切れです",
    "err.email_failed": "メール送信に失敗しました",
    "err.admin_only": "管理者のみ",
    "err.email_required": "有効なメールが必要です",
    "err.no_change": "変更なし",
    "csv.firstName": "名", "csv.lastName": "姓", "csv.birth": "生年月日", "csv.weight": "体重", "csv.belt": "帯", "csv.school": "TKD 道場", "csv.height": "身長", "csv.sex": "性別", "csv.compType": "競技種別",
    "dash.duration": "期間（日）", "dash.days": "日", "status.programmato": "予定", "status.in_corso": "進行中", "status.concluso": "終了", "status.non_svolto": "未開催",
    "set.tokensOwner": "トークンはイベント所有者の残高からのみ差し引かれます。", "collab.title": "共同管理者の管理", "collab.desc": "役割の割り当て・削除は所有者のみ可能です。", "collab.roleOwner": "所有者", "collab.roleCo": "共同主催者", "collab.roleReg": "登録担当", "collab.roleObs": "閲覧者", "collab.email": "共同管理者の KIHAP メール", "collab.add": "招待を作成", "collab.linkCreated": "招待リンクを作成・コピーしました — 相手に送ってください。", "collab.none": "共同管理者はいません。", "collab.confirmRemoveTitle": "共同管理者を削除しますか？", "collab.confirmRemoveDesc": "{name} は直ちにイベントへのアクセスを失います。保留中の招待リンクは無効になります。後で再び招待できます。", "collab.confirmRemoveBtn": "削除", "forgot.title": "アクセスを復旧", "forgot.desc": "アカウントに登録されているメールアドレスを入力してください。アカウントにアクセスするためのメールをお送りします。", "forgot.cta": "復旧リンクを送信", "forgot.back": "ログインに戻る", "forgot.sentTitle": "メールをご確認ください", "forgot.sentMsg": "このアドレスのアカウントが存在する場合、ログイン用のメールをお送りしました：", "club.title": "クラブ順位", "club.desc": "クラブの順位付け方法を選択します。", "club.method": "順位付け方法", "club.methodMedals": "金メダル数順（オリンピック方式）", "club.methodPoints": "ポイント順", "club.goldPts": "金1つあたりのポイント", "club.silverPts": "銀1つあたりのポイント", "club.bronzePts": "銅1つあたりのポイント", "club.doubleBronze": "ダブル銅", "club.doubleBronzeHint": "オンにすると3位と4位の両方に銅を付与します（どちらもメダル集計に含まれます）。", "ev.tabOffline": "オフラインモード", "off.title": "オフライン / LAN モード", "off.desc": "PCで実行する KIHAP Server Tournament をダウンロードします。審判とリングはルーターのローカルWiFiで接続し、インターネットは不要です。", "off.estimate": "このイベントの推定トークン", "off.breakdown": "組手 {combat} 試合 × 2 トークン + プムセ評価 {poomsae} 件", "off.tiebreak": "イベント中、同点を処理するために追加の評価が必要になる場合があります。こうした場合に備えて予備のトークンを15個確保してください。", "off.balance": "現在の残高", "off.deductNote": "サーバーをダウンロードすると、残高から {n} トークンが差し引かれ、このイベントのパッケージに読み込まれます。", "off.aiOff": "ローカルLANモードではAI機能は無効になります。", "off.download": "KIHAP Server Tournament をダウンロード", "off.downloading": "パッケージを準備中...", "off.ready": "ダウンロードを開始しました。", "off.notEnough": "サーバーをダウンロードするトークンが不足しています。", "off.ownerOnly": "イベント所有者のみサーバーをダウンロードできます。", "offtok.warn": "注意: トークン残り {n}", "offtok.low": "トークンは残り {n} のみ！", "offtok.emptyTitle": "トークン切れ", "offtok.emptyMsg": "評価は一時停止中です。続けるには、PCをインターネットに接続し、トークンを追加購入してイベントサーバーを再ダウンロードしてください。", "offtok.dismiss": "閲覧を続ける", "offtok.suspended": "トークン切れ — 新規評価は停止中", "srv.scan": "スキャンして接続", "srv.judgesScan": "審判: 担当リングをスキャン", "srv.offlineOnly": "このページはオフライン（LAN）モードでのみ利用できます。", "srv.noRings": "リングが未設定です", "res.clubs": "クラブ", "clubres.club": "クラブ", "clubres.athletes": "選手", "clubres.gold": "金", "clubres.silver": "銀", "clubres.bronze": "銅", "clubres.points": "ポイント", "clubres.rank": "順位", "clubres.noClub": "クラブなし", "invite.title": "共同作業の招待", "invite.accept": "招待を承認", "invite.wrongEmail": "この招待は別のメールアカウント宛です。招待されたメールでログインしてください。", "invite.accepted": "招待を承認しました！", "err.invite_wrong_email": "この招待は別のメールアカウント宛です。",
  },
  ar: {
    "login.title": "تسجيل الدخول",
    "login.subtitle": "منطقة المنظّم",
    "common.email": "البريد الإلكتروني",
    "common.password": "كلمة المرور",
    "login.enter": "دخول",
    "login.accessing": "جارٍ الدخول…",
    "login.noAccount": "ليس لديك حساب؟",
    "login.register": "إنشاء حساب",
    "login.areYouRing": "هل أنت حَلبة؟",
    "login.ringLogin": "دخول الحلبة",
    "login.identifier": "البريد الإلكتروني",
    "register.sentTitle": "تحقق من بريدك",
    "register.sentMsg": "أرسلنا رابط التأكيد إلى",
    "register.sentHint": "انقر على الرابط في البريد لتفعيل حسابك. تحقق من مجلد السبام أيضًا.",
    "register.resend": "إعادة إرسال بريد التأكيد",
    "register.resent": "تمت إعادة إرسال البريد",
    "register.resendWait": "أعد المحاولة بعد {s} ثانية",
    "verify.verifying": "جارٍ التحقق…",
    "verify.ok": "تم تفعيل الحساب! جارٍ تسجيل الدخول…",
    "verify.invalid": "رابط غير صالح أو منتهٍ. يرجى التسجيل مجددًا.",
    "hero.l1": "أدِر",
    "hero.l2": "التايكوندو",
    "hero.l3": "بطولات",
    "hero.sub": "الفعاليات واللاعبون والمجموعات والحلبات ولوحات النتائج المباشرة في منصة ويب واحدة.",
    "register.title": "إنشاء حساب",
    "register.name": "الاسم",
    "register.cta": "سجّل واحصل على 100 رمز",
    "register.creating": "جارٍ الإنشاء…",
    "register.haveAccount": "لديك حساب بالفعل؟",
    "register.login": "تسجيل الدخول",
    "dash.events": "فعالياتك",
    "dash.eventsSub": "أنشئ وأدِر بطولاتك.",
    "dash.newEvent": "فعالية جديدة",
    "dash.eventName": "اسم الفعالية",
    "dash.type": "النوع",
    "dash.date": "التاريخ",
    "dash.deleteTitle": "حذف الفعالية",
    "dash.deleteWarn": "هل أنت متأكد من حذف هذه الفعالية؟ هذا الإجراء لا يمكن التراجع عنه ويحذف أيضًا اللاعبين والمجموعات والحلبات والمباريات.\nللتأكيد اكتب اسم الفعالية في الحقل أدناه.",
    "dash.clickToCopy": "انقر للنسخ",
    "dash.deleteCta": "حذف نهائي",
    "dash.cancel": "إلغاء",
    "ath.edit": "تعديل اللاعب",
    "ath.updated": "تم تحديث اللاعب",
    "ath.lockedDiscipline": "التخصص محدد حسب نوع الفعالية.",
    "common.delete": "حذف",
    "dash.create": "إنشاء فعالية",
    "dash.empty": "لا توجد فعاليات. أنشئ واحدة للبدء.",
    "dash.token": "رموز",
    "banner.tokensZero": "نفدت الرموز. اشحن للمتابعة.",
    "banner.tokensZeroCta": "انقر هنا للشحن",
    "dash.namePlaceholder": "مثال: كأس المدينة 2026",
    "dash.confirmDelete": "حذف هذه الفعالية وكل بياناتها؟",
    "dash.deleted": "تم حذف الفعالية",
    "dash.created": "تم إنشاء الفعالية",
    "dash.enterName": "أدخل اسمًا",
    "type.combat": "الكيوروجي",
    "type.poomsae": "بومسي",
    "type.mixed": "مختلط",
    "type.poomsaeForms": "بومسي (أشكال)",
    "ev.tabAthletes": "اللاعبون",
    "ev.tabPools": "المجموعات والمباريات",
    "ev.tabRings": "الحلبات",
    "ev.tabSettings": "الإعدادات",
    "common.loading": "جارٍ التحميل…",
    "ath.title": "اللاعبون",
    "ath.templateCsv": "تنزيل القالب (CSV)",
    "ath.import": "استيراد اللاعبين (CSV)",
    "ath.exportCsv": "تنزيل اللاعبين (CSV)",
    "ath.add": "إضافة",
    "ath.new": "لاعب جديد",
    "ath.firstName": "الاسم",
    "ath.lastName": "اللقب",
    "ath.birth": "تاريخ الميلاد",
    "ath.weight": "الوزن (كغ)",
    "ath.belt": "الحزام",
    "ath.height": "الطول (سم)",
    "ath.disciplines": "التخصصات",
    "ath.save": "حفظ اللاعب",
    "ath.colName": "اللقب الاسم",
    "ath.colBirth": "الميلاد",
    "ath.colWeight": "الوزن",
    "ath.colBelt": "الحزام",
    "ath.colDisc": "التخصصات",
    "ath.empty": "لا يوجد لاعبون. أضِف أو استورد من CSV/Excel.",
    "ath.reqNames": "الاسم واللقب مطلوبان",
    "ath.added": "تمت إضافة اللاعب",
    "ath.imported": "تم استيراد {n} لاعبًا",
    "pool.title": "المجموعات",
    "pool.aiSuggest": "اقترح بالذكاء الاصطناعي",
    "pool.aiWorking": "الذكاء الاصطناعي يعمل…",
    "pool.autoGen": "توليد تلقائي",
    "pool.autoTitle": "توليد المجموعات تلقائيًا",
    "pool.autoDesc": "يجمّع اللاعبين حسب الفئة العمرية والحزام والوزن وفق قواعد التايكوندو.",
    "pool.method": "الطريقة",
    "pool.methodLocal": "محلي (متاح دائمًا)",
    "pool.methodAi": "ذكاء اصطناعي (مُوصى به، يتطلب شبكة)",
    "pool.minSize": "أدنى عدد لاعبين/مجموعة",
    "pool.maxSize": "أقصى عدد لاعبين/مجموعة",
    "pool.weightTol": "تفاوت الوزن (٪ من وزن الجسم)",
    "pool.weightTolShort": "تفاوت الوزن ٪",
    "pool.ageTolShort": "تفاوت العمر ٪",
    "pool.heightTolShort": "تفاوت الطول ٪",
    "pool.beltTolShort": "تفاوت الحزام ٪",
    "pool.mixedPools": "مجموعات مختلطة (مختلطة إذا فُعِّلت)",
    "pool.tolHint": "‏100٪ يعني تجاهل هذا المعيار.",
    "pool.replace": "استبدال المجموعات الحالية",
    "pool.generate": "توليد المجموعات",
    "pool.generating": "جارٍ التوليد…",
    "pool.autoCreated": "تم توليد {n} مجموعة",
    "pool.aiFallback": "الذكاء الاصطناعي غير متاح: استُخدم المحرك المحلي ({n} مجموعة)",
    "pool.overrideTitle": "إعدادات المجموعة",
    "pool.overrideDesc": "تجاوز إعدادات الفعالية لهذه المجموعة فقط (مثل جولات أقصر للأطفال).",
    "pool.overrideHint": "أعد توليد مباريات المجموعة لتطبيق التغييرات.",
    "pool.overrideActive": "مخصص",
    "pool.overrideSaved": "تم حفظ إعدادات المجموعة",
    "pool.overrideReset": "إعادة ضبط للفعالية",
    "rc.offline": "غير متصل",
    "rc.clearJudges": "إزالة الحكام",
    "rc.clearJudgesConfirm": "فصل جميع الحكام عن هذه الحلبة؟",
    "rc.judgesCleared": "تمت إزالة الحكام",
    "rc.resetJudges": "إعادة ضبط الحكام",
    "rc.resetConfirm": "إعادة ضبط شاشات الحكام؟ سيتم مسح تقييماتهم الجارية.",
    "rc.judgesReset": "تمت إعادة ضبط شاشات الحكام",
    "ath.sex": "الجنس",
    "ath.female": "إناث",
    "ath.male": "ذكور",
    "ath.noSex": "غير محدد",
    "pool.renamePrompt": "اسم المجموعة (يمكنك إضافة ملاحظة، مثل «المجموعة 1، الناشئون»):",
    "j.leave": "خروج",
    "j.add": "إضافة",
    "ring.accessQr": "الوصول إلى المحطة",
    "ring.scanStation": "امسح رمز QR من جهاز لوحي/هاتف لفتح هذه الحلبة، أو انسخ رابطًا (مفيد أيضًا على الحاسوب).",
    "ring.quickLink": "انسخ الرابط السريع (دخول تلقائي)",
    "ring.secureLink": "انسخ الرابط الآمن (يطلب كلمة مرور)",
    "err.generic": "حدث خطأ ما. حاول مرة أخرى.",
    "err.token_expired": "انتهت الجلسة. سجّل الدخول مجددًا.",
    "err.invalid_token": "رمز غير صالح.",
    "err.not_authenticated": "غير مُصادَق.",
    "err.user_not_found": "المستخدم غير موجود.",
    "err.event_not_found": "الفعالية غير موجودة.",
    "err.email_taken": "البريد مسجّل بالفعل.",
    "err.invalid_credentials": "بيانات اعتماد غير صحيحة.",
    "err.ring_password_wrong": "كلمة مرور الحلبة خاطئة.",
    "err.ring_not_found": "الحلبة غير موجودة.",
    "err.athlete_not_found": "اللاعب غير موجود.",
    "err.file_read": "تعذّر قراءة الملف. تحقق من التنسيق.",
    "err.pool_not_found": "المجموعة غير موجودة.",
    "err.tiebreak_only_score": "الفاصل متاح فقط لمجموعات البومسي بالنقاط.",
    "err.tiebreak_need_two": "يلزم لاعبان على الأقل للفاصل.",
    "err.pool_not_found_event": "المجموعة غير موجودة في هذه الفعالية.",
    "err.no_athletes_discipline": "لا يوجد لاعبون لهذا التخصص.",
    "err.match_not_found": "المباراة غير موجودة.",
    "err.access_denied": "تم رفض الوصول.",
    "err.judges_not_ready": "الحكام غير جاهزين ({n}).",
    "err.tokens_exhausted": "نفدت الرموز. اشحن للمتابعة.",
    "err.unknown_action": "إجراء غير معروف.",
    "err.invalid_judge_token": "رمز الحكم غير صالح.",
    "err.invalid_package": "الباقة غير صالحة.",
    "err.price_not_found": "السعر غير موجود.",
    "err.transaction_not_found": "المعاملة غير موجودة.",
    "err.invalid_signature": "توقيع غير صالح.",
    "pool.new": "مجموعة جديدة",
    "pool.unassigned": "غير معيّن",
    "pool.athletes": "{n} لاعبين",
    "pool.allAssigned": "تم تعيين الجميع.",
    "pool.dragHere": "اسحب اللاعبين إلى هنا.",
    "pool.genMatches": "توليد المباريات",
    "pool.matches": "{n} مباراة",
    "pool.needMore": "يلزم مزيد من اللاعبين",
    "pool.aiCreated": "الذكاء الاصطناعي: تم إنشاء {n} مجموعة",
    "pool.moveError": "خطأ في النقل",
    "pool.matchesGenerated": "تم توليد {n} مباراة",
    "bracket.single_elim": "إقصاء مباشر",
    "bracket.round_robin": "دوري",
    "bracket.group_elim": "مجموعات + إقصاء",
    "bracket.score": "بالنقاط",
    "ring.title": "الحلبات والتعيينات",
    "ring.name": "اسم الحلبة",
    "ring.number": "الرقم",
    "ring.discipline": "التخصص",
    "ring.create": "إنشاء حلبة",
    "ring.created": "تم إنشاء الحلبة",
    "ring.none": "لا توجد حلبات. أنشئ واحدة لتعيين المباريات.",
    "ring.assigned": "تم تعيين {n} مباراة",
    "ring.eventId": "معرّف الفعالية",
    "ring.ringId": "معرّف الحلبة",
    "ring.password": "كلمة المرور",
    "ring.assignPool": "تعيين مجموعة…",
    "ring.assign": "تعيين",
    "ring.openStation": "فتح الحلبة",
    "ring.selectPool": "اختر مجموعة",
    "ring.genFirst": "ولّد المباريات أولًا",
    "ring.copied": "تم النسخ",
    "ring.assignedToast": "تم تعيين {n} مباراة إلى {ring}",
    "ring.assignedPools": "المجموعات المعيّنة (بالترتيب)",
    "ring.removePool": "إزالة المجموعة من الحلبة",
    "ring.printRing": "طباعة ورقة الحلبة",
    "ring.poolRemoved": "تمت إزالة المجموعة من الحلبة",
    "ring.allPoolsAssigned": "جميع المجموعات معيّنة بالفعل",
    "filter.both": "الكيوروجي والبومسي",
    "filter.combat": "الكيوروجي",
    "filter.poomsae": "بومسي",
    "set.title": "إعدادات الفعالية",
    "set.sub": "قيم افتراضية لجميع المباريات؛ يمكنك تغييرها لكل مباراة أيضًا.",
    "set.combat": "الكيوروجي",
    "set.rounds": "عدد الجولات",
    "set.roundDur": "مدة الجولة (s)",
    "set.break": "استراحة (s)",
    "set.koDiff": "فارق نقاط الضربة القاضية الفنية",
    "set.consensusWindow": "نافذة التوافق (s)",
    "set.consensusHint": "الثواني التي يجب أن يتفق خلالها أغلب الحكام لمنح النقطة (0.2–2.0).",
    "set.judges": "عدد الحكام",
    "set.poomsae": "بومسي",
    "set.forms": "الأشكال لكل لاعب",
    "set.ringAccess": "الوصول إلى الحلبة",
    "set.ringPw": "كلمة مرور الحلبة (مشتركة)",
    "set.ringPwHint": "تستخدمها حواسيب الحلبات للاتصال بالفعالية.",
    "set.save": "حفظ الإعدادات",
    "set.saving": "جارٍ الحفظ…",
    "set.saved": "تم حفظ الإعدادات",
    "set.tokensTitle": "الرموز",
    "set.tokensPoomsae": "كل تقييم بومسي يتطلب رمزًا واحدًا.",
    "set.tokensCombat": "كل مباراة كيوروجي (بأي عدد جولات) تتطلب رمزين.",
    "set.tokensCheck": "تأكد من امتلاك رموز كافية لتشغيل فعاليتك.",
    "set.tokensReload": "اشحن الرموز",
    "rl.title": "دخول الحلبة",
    "rl.back": "العودة لتسجيل الدخول",
    "rl.sub": "سجّل الدخول كمحطة حلبة لإدارة المباريات.",
    "rl.connect": "اتصال الحلبة",
    "rl.connecting": "جارٍ الاتصال…",
    "rl.connected": "متصل: {name}",
    "rc.queue": "الطابور",
    "rc.judges": "الحكام",
    "rc.monitor": "الشاشة",
    "rc.incontri": "المباريات",
    "rc.noneAssigned": "لا توجد مباريات معيّنة.",
    "rc.colJudge": "الحكم",
    "rc.colTech": "التقييم الفني",
    "rc.colBalance": "التوازن",
    "rc.colRhythm": "الإيقاع",
    "rc.colPower": "القوة",
    "rc.colTotal": "المجموع",
    "rc.colAvg": "المعدل",
    "rc.noVotesYet": "بانتظار تقييمات الحكام…",
    "rc.selectMatch": "اختر مباراة من الطابور.",
    "rc.round": "الجولة",
    "rc.break": "استراحة",
    "rc.start": "بدء",
    "rc.pause": "إيقاف مؤقت",
    "rc.reset": "إعادة ضبط",
    "rc.resetMatch": "إعادة ضبط",
    "rc.resetMatchConfirm": "إعادة المباراة؟ ستُمسح النتيجة وسيُخصم رمزان مجددًا عند إعادة البدء.",
    "rc.resetMatchHint": "إعادة البدء تستهلك رمزين مجددًا.",
    "rc.matchReset": "تمت إعادة ضبط المباراة",
    "err.match_locked": "النتيجة مقفلة: استخدم إعادة الضبط لإعادة المباراة.",
    "rc.roundPlus": "جولة +",
    "rc.roundExtraHint": "الجولة الإضافية متاحة فقط عند التعادل بعد الجولات المقررة.",
    "err.round_not_tied": "الجولة الإضافية مسموحة فقط عند التعادل.",
    "rc.medical": "وقت طبي",
    "rc.soundOn": "الصوت مفعّل (نهاية الجولة والاستراحة)",
    "rc.soundOff": "الصوت معطّل",
    "rc.waitingJudges": "بانتظار جاهزية الحكام ({r}/{n})",
    "rc.winner": "الفائز: {name}",
    "rc.performing": "قيد الأداء",
    "rc.tie": "تعادل",
    "rc.tieHint": "تساوي المعدل: فكّر في فاصل ترجيح.",
    "rc.koTitle": "الضربة القاضية الفنية",
    "rc.koMsg": "تم بلوغ فارق النقاط. هل تعلن {name} فائزًا بالضربة القاضية الفنية؟",
    "rc.koConfirm": "تأكيد الضربة القاضية",
    "rc.koContinue": "متابعة المباراة",
    "mon.performing": "قيد الأداء",
    "res.reshuffle": "إعادة القرعة",
    "pool.drawPreview": "معاينة المباريات",
    "pool.downloadPdf": "تنزيل PDF",
    "common.pdf": "PDF",
    "pool.execOrder": "ترتيب الأداء",
    "pool.bye": "(تأهل تلقائي)",
    "res.reshuffleConfirm": "إعادة توليد القرعة بمزاوجة عشوائية جديدة؟",
    "res.reshuffled": "تمت القرعة الجديدة",
    "res.swapHint": "انقر على لاعبين من الجولة الأولى لتبديل موقعيهما.",
    "res.tiebreak": "فواصل الترجيح",
    "res.tiebreakBtn": "إنشاء فاصل ترجيح",
    "res.tiebreakRegen": "إعادة توليد الفاصل",
    "res.tiebreakCreated": "تم إنشاء الفاصل: نفّذه في الحلبة",
    "res.tiebreakPending": "فاصل ترجيح جارٍ",
    "rc.winnerDecreed": "تم إعلان الفائز",
    "rc.point": "نقطة",
    "rc.wins": "فوز",
    "rc.warnLight": "إنذارات خفيفة:",
    "rc.warnSevere": "إنذارات شديدة:",
    "rc.judgesQr": "الحكام عبر QR",
    "rc.ready": "جاهز",
    "rc.noJudges": "لا يوجد حكام متصلون.",
    "rc.requireReady": "اشترط جاهزية الحكام",
    "rc.startPerf": "بدء الأداء",
    "rc.waitingReady": "بانتظار جاهزية الحكام",
    "rc.startConsumes": "البدء يستهلك رمزًا واحدًا ويفتح تقييم الحكام.",
    "rc.form": "بومسي",
    "rc.avgAuto": "يُحتسب معدل الحكام تلقائيًا بمجرد إرسال الجميع تقييم الشكل الحالي.",
    "rc.avgTotal": "المعدل الإجمالي",
    "rc.confirmPerf": "تأكيد وإنهاء الأداء",
    "rc.confirmPerformance": "تأكيد الأداء",
    "rc.perfConfirmed": "تم تأكيد الأداء",
    "rc.cancelPerformance": "إلغاء الأداء",
    "rc.cancelPerfConfirm": "إلغاء الأداء؟ ستُعاد النقاط للصفر ويعيد الحكام التصويت.",
    "rc.removeJudge": "إزالة الحكم",
    "rc.removeJudgeConfirm": "إزالة هذا الحكم من الحلبة؟",
    "rc.judgeRemoved": "تمت إزالة الحكم",
    "j.access": "دخول الحكم",
    "j.yourName": "اسمك",
    "j.ready": "جاهز",
    "j.waitingMatch": "بانتظار أن تختار الحلبة مباراة…",
    "j.assignPoints": "امنح النقاط — أمسك الهاتف أفقيًا",
    "j.technical": "التقييم الفني",
    "j.form": "بومسي",
    "j.errLight": "خطأ خفيف",
    "j.errSevere": "خطأ شديد",
    "j.energy": "الطاقة",
    "j.balance": "التوازن",
    "j.rhythm": "الإيقاع",
    "j.total": "المجموع",
    "j.send": "إرسال التقييم",
    "j.readyFirst": "أكّد جاهزيتك أولًا",
    "j.sent": "تم الإرسال",
    "j.voteSent": "تم إرسال التقييم: {v}",
    "mon.waiting": "بانتظار المباراة",
    "mon.warnLight": "إنذار خفيف",
    "mon.warnSevere": "إنذار شديد",
    "mon.round": "الجولة",
    "mon.break": "استراحة",
    "mon.medical": "طبي",
    "mon.winner": "الفائز",
    "mon.form": "بومسي",
    "mon.avg": "المعدل",
    "bill.title": "اشحن الرموز",
    "bill.sub": "رمزان لكل مباراة كيوروجي، ورمز واحد لكل أداء بومسي.",
    "bill.custom": "كمية مخصصة",
    "bill.token": "رموز",
    "bill.perToken": "/ رمز",
    "bill.buy": "شراء",
    "bill.redirecting": "جارٍ التحويل…",
    "bill.checkoutTitle": "أكمل الدفع",
    "bill.checkoutSub": "رموز · €",
    "bill.loading": "جارٍ تحميل الدفع…",
    "bill.best": "أفضل قيمة",
    "bill.secure": "مدفوعات آمنة عبر Stripe.",
    "bill.secureLive": "مدفوعات آمنة عبر Stripe وPayPal.",
    "bill.orPaypal": "أو ادفع عبر PayPal",
    "bill.paypalSuccess": "اكتمل الدفع عبر PayPal، وأُضيفت الرموز!",
    "bill.paypalError": "فشل الدفع عبر PayPal. حاول مجددًا.",
    "pay.checking": "جارٍ تأكيد الدفع…",
    "pay.success": "تم الدفع بنجاح",
    "pay.added": "تمت إضافة {n} رمز إلى حسابك.",
    "pay.backDash": "العودة إلى لوحة التحكم",
    "pay.pending": "جارٍ معالجة الدفع. ستظهر الرموز قريبًا.",
    "pay.dashboard": "لوحة التحكم",
    "pay.error": "حدث خطأ ما",
    "pay.retry": "إعادة المحاولة",
    "pay.cancelled": "تم إلغاء الدفع",
    "pay.backPackages": "العودة إلى الباقات",
    "ev.tabResults": "النتائج",
    "res.champion": "البطل",
    "res.title": "النتائج",
    "res.export": "تنزيل النتائج",
    "res.exportTitle": "نتائج البطولة",
    "res.standings": "الترتيب",
    "res.wins": "انتصارات",
    "res.noData": "لم تُولَّد مباريات. اذهب إلى المجموعات لتوليدها.",
    "res.round": "الجولة",
    "res.pending": "معلّق",
    "res.avg": "المعدل",
    "res.tbd": "يُحدد لاحقًا",
    "res.bye": "تأهل تلقائي",
    "admin.link": "إدارة KIHAP",
    "admin.back": "العودة إلى لوحة التحكم",
    "admin.createTitle": "إنشاء حساب",
    "admin.email": "البريد الإلكتروني",
    "admin.name": "الاسم",
    "admin.tokens": "الرموز",
    "admin.password": "كلمة المرور",
    "admin.pwManual": "تعيين كلمة المرور يدويًا",
    "admin.pwAutoHint": "مولّدة تلقائيًا",
    "admin.create": "إنشاء حساب",
    "admin.created": "تم إنشاء الحساب",
    "admin.genPw": "كلمة المرور المولّدة (انسخها الآن):",
    "admin.copy": "نسخ",
    "admin.copied": "تم النسخ",
    "admin.usersTitle": "المستخدمون",
    "admin.search": "ابحث بالبريد أو الاسم",
    "admin.role": "الدور",
    "admin.balance": "الرموز",
    "admin.save": "حفظ",
    "admin.updated": "تم تحديث الرموز",
    "admin.delete": "حذف الحساب",
    "admin.deleted": "تم حذف الحساب",
    "admin.confirmDelete": "حذف الحساب {email} نهائيًا؟",
    "err.cannot_delete_admin": "لا يمكنك حذف حساب مسؤول",
    "admin.noUsers": "لا يوجد مستخدمون",
    "admin.error": "فشلت العملية",
    "acct.title": "الإعدادات",
    "acct.account": "حسابك",
    "acct.username": "اسم المستخدم",
    "acct.usernameHint": "الاسم الذي اخترته عند التسجيل: يظهر في كل أنحاء التطبيق.",
    "acct.email": "البريد الإلكتروني",
    "acct.tokenCredit": "رصيد الرموز",
    "acct.editName": "تعديل اسم المستخدم",
    "acct.nameSaved": "تم تحديث الاسم",
    "err.name_taken": "اسم المستخدم مستخدم بالفعل.",
    "err.name_required": "أدخل اسم مستخدم.",
    "acct.pwEncrypted": "كلمة المرور مشفّرة ولا يمكن عرضها لأسباب أمنية. يمكنك تغييرها أدناه.",
    "acct.changePw": "تغيير كلمة المرور",
    "acct.oldPw": "كلمة المرور الحالية",
    "acct.newPw": "كلمة المرور الجديدة",
    "acct.confirmPw": "تأكيد كلمة المرور الجديدة",
    "acct.pwMismatch": "كلمتا المرور غير متطابقتين.",
    "acct.pwChanged": "تم تحديث كلمة المرور",
    "acct.recovery": "بريد الاسترداد",
    "acct.recoveryHint": "يُستخدم لاسترداد الوصول: ستتلقى اسم المستخدم ورابط إعادة تعيين كلمة المرور.",
    "acct.recoveryEmail": "بريد الاسترداد",
    "acct.recoveryEdit": "تعديل بريد الاسترداد",
    "acct.recoverySaved": "تم حفظ بريد الاسترداد",
    "acct.antiPhish": "رمز مكافحة التصيّد",
    "acct.antiPhishHint": "رمز موجود في كل بريد من KIHAP: إن لم يظهر في بريد فهو محاولة تصيّد.",
    "acct.antiPhishEdit": "تعديل رمز مكافحة التصيّد",
    "acct.antiPhishSaved": "تم حفظ رمز مكافحة التصيّد",
    "acct.movements": "حركات الرموز",
    "acct.noMovements": "لا مشتريات بعد",
    "acct.date": "التاريخ",
    "acct.tokens": "الرموز",
    "acct.amount": "المبلغ",
    "acct.method": "الطريقة",
    "acct.dangerZone": "منطقة الخطر",
    "acct.deleteAccount": "حذف الحساب",
    "acct.deleteWarnShort": "الحذف يعني فقدانًا دائمًا لكل الفعاليات التي أنشأتها ومعلومات اللاعبين والرموز المشتراة.",
    "acct.deleteTitle": "حذف الحساب",
    "acct.deleteWarn": "الحذف يعني فقدانًا دائمًا لكل الفعاليات التي أنشأتها ومعلومات اللاعبين والرموز المشتراة. لحذف الحساب نهائيًا اكتب اسم حسابك في الحقل أدناه وأكّد.",
    "acct.deleteCta": "حذف نهائي",
    "acct.deleteSuccess": "تم حذف الحساب",
    "acct.deleteAdminNote": "لا يمكن حذف حسابات المسؤولين.",
    "acct.error": "فشلت العملية",
    "rpw.title": "إعادة تعيين كلمة المرور",
    "rpw.submit": "إعادة تعيين",
    "rpw.done": "تمت إعادة تعيين كلمة المرور. يمكنك الآن تسجيل الدخول.",
    "rpw.invalid": "رابط غير صالح أو منتهٍ.",
    "login.forgot": "هل نسيت كلمة المرور؟",
    "login.forgotPrompt": "أدخل بريد الاسترداد (المحدد في الإعدادات):",
    "login.forgotSent": "إن وُجد بريد استرداد، فقد أرسلنا التعليمات.",
    "err.old_password_wrong": "كلمة المرور الحالية خاطئة",
    "err.password_short": "يجب ألا تقل كلمة المرور عن 6 أحرف",
    "err.reset_invalid": "رابط إعادة التعيين غير صالح أو منتهٍ",
    "err.email_failed": "فشل إرسال البريد",
    "err.admin_only": "للمسؤولين فقط",
    "err.email_required": "بريد صالح مطلوب",
    "err.no_change": "لا تغيير",
    "csv.firstName": "الاسم", "csv.lastName": "اللقب", "csv.birth": "تاريخ الميلاد", "csv.weight": "الوزن", "csv.belt": "الحزام", "csv.school": "مدرسة TKD", "csv.height": "الطول", "csv.sex": "الجنس", "csv.compType": "نوع المسابقة",
    "dash.duration": "المدة (أيام)", "dash.days": "أيام", "status.programmato": "مُجدوَل", "status.in_corso": "قيد التنفيذ", "status.concluso": "منتهٍ", "status.non_svolto": "لم يُقَم",
    "set.tokensOwner": "تُخصم الرموز من رصيد مالك الفعالية فقط.", "collab.title": "إدارة المتعاونين", "collab.desc": "المالك فقط يمكنه تعيين أو إزالة الأدوار.", "collab.roleOwner": "المالك", "collab.roleCo": "منظّم مشارك", "collab.roleReg": "مسؤول التسجيل", "collab.roleObs": "مراقب", "collab.email": "بريد KIHAP للمتعاون", "collab.add": "إنشاء دعوة", "collab.linkCreated": "تم إنشاء رابط الدعوة ونسخه — أرسله إلى المتعاون.", "collab.none": "لا يوجد متعاونون.", "collab.confirmRemoveTitle": "إزالة المتعاون؟", "collab.confirmRemoveDesc": "سيفقد {name} فورًا إمكانية الوصول إلى الفعالية. وسيصبح أي رابط دعوة معلّق غير صالح. يمكنك دعوته مرة أخرى لاحقًا.", "collab.confirmRemoveBtn": "إزالة", "forgot.title": "استعادة الوصول", "forgot.desc": "أدخل عنوان البريد الإلكتروني المرتبط بحسابك وسنرسل لك بريدًا للوصول إلى حسابك.", "forgot.cta": "إرسال رابط الاستعادة", "forgot.back": "العودة إلى تسجيل الدخول", "forgot.sentTitle": "تحقق من بريدك الإلكتروني", "forgot.sentMsg": "إذا كان هناك حساب بهذا العنوان، فقد أرسلنا إليك بريدًا لتسجيل الدخول:", "club.title": "ترتيب الأندية", "club.desc": "اختر طريقة ترتيب الأندية.", "club.method": "طريقة الترتيب", "club.methodMedals": "حسب الميداليات الذهبية (النمط الأولمبي)", "club.methodPoints": "حسب النقاط", "club.goldPts": "نقاط لكل ذهبية", "club.silverPts": "نقاط لكل فضية", "club.bronzePts": "نقاط لكل برونزية", "club.doubleBronze": "برونزية مزدوجة", "club.doubleBronzeHint": "عند التفعيل، تُمنح البرونزية للمركزين الثالث والرابع (كلاهما يُحتسب في جدول الميداليات).", "ev.tabOffline": "وضع عدم الاتصال", "off.title": "وضع عدم الاتصال / الشبكة المحلية", "off.desc": "نزّل KIHAP Server Tournament لتشغيله على جهازك. يتصل الحكام والحلبات عبر شبكة WiFi المحلية للراوتر دون الحاجة إلى الإنترنت.", "off.estimate": "الرموز المقدّرة لهذه الفعالية", "off.breakdown": "{combat} نزالات × رمزان + {poomsae} تقييمات بومسي", "off.tiebreak": "قد تكون هناك حاجة إلى تقييمات إضافية أثناء الفعالية لمعالجة حالات التعادل. تأكد من توفّر 15 رمزًا إضافيًا لهذه الحالات.", "off.balance": "رصيدك الحالي", "off.deductNote": "عند تنزيل الخادم، سيتم خصم {n} رمزًا من رصيدك وتحميلها في الحزمة لهذه الفعالية.", "off.aiOff": "في وضع الشبكة المحلية، تكون ميزات الذكاء الاصطناعي معطّلة.", "off.download": "تنزيل KIHAP Server Tournament", "off.downloading": "جارٍ تحضير الحزمة...", "off.ready": "بدأ التنزيل.", "off.notEnough": "الرموز غير كافية لتنزيل الخادم.", "off.ownerOnly": "يمكن لمالك الفعالية فقط تنزيل الخادم.", "offtok.warn": "تنبيه: تبقّى {n} رمزًا", "offtok.low": "لم يتبقَّ سوى {n} رموز!", "offtok.emptyTitle": "نفدت الرموز", "offtok.emptyMsg": "التقييمات متوقفة مؤقتًا. للمتابعة، وصّل الجهاز بالإنترنت واشترِ المزيد من الرموز ثم أعد تنزيل خادم الفعالية.", "offtok.dismiss": "متابعة التصفح", "offtok.suspended": "نفدت الرموز — تم إيقاف التقييمات الجديدة", "srv.scan": "امسح للاتصال", "srv.judgesScan": "الحكام: امسحوا حلبتكم", "srv.offlineOnly": "هذه الصفحة متاحة فقط في وضع عدم الاتصال (LAN).", "srv.noRings": "لا توجد حلبات مُهيأة", "res.clubs": "الأندية", "clubres.club": "النادي", "clubres.athletes": "الرياضيون", "clubres.gold": "ذهب", "clubres.silver": "فضة", "clubres.bronze": "برونز", "clubres.points": "النقاط", "clubres.rank": "الترتيب", "clubres.noClub": "بدون نادٍ", "invite.title": "دعوة للتعاون", "invite.accept": "قبول الدعوة", "invite.wrongEmail": "هذه الدعوة لحساب بريد آخر. سجّل الدخول بالبريد المدعو.", "invite.accepted": "تم قبول الدعوة!", "err.invite_wrong_email": "هذه الدعوة لحساب بريد آخر.",
  },
  hi: {
    "login.title": "लॉग इन",
    "login.subtitle": "आयोजक क्षेत्र",
    "common.email": "ईमेल",
    "common.password": "पासवर्ड",
    "login.enter": "प्रवेश",
    "login.accessing": "लॉग इन हो रहा है…",
    "login.noAccount": "खाता नहीं है?",
    "login.register": "रजिस्टर करें",
    "login.areYouRing": "क्या आप रिंग हैं?",
    "login.ringLogin": "रिंग लॉगिन",
    "login.identifier": "ईमेल",
    "register.sentTitle": "अपना ईमेल जांचें",
    "register.sentMsg": "हमने पुष्टि लिंक भेजा है",
    "register.sentHint": "खाता सक्रिय करने के लिए ईमेल के लिंक पर क्लिक करें। स्पैम भी जांचें।",
    "register.resend": "पुष्टि ईमेल फिर भेजें",
    "register.resent": "ईमेल फिर भेजा गया",
    "register.resendWait": "{s} सेकंड में पुनः प्रयास",
    "verify.verifying": "सत्यापन हो रहा है…",
    "verify.ok": "खाता सक्रिय! लॉग इन किया जा रहा है…",
    "verify.invalid": "लिंक अमान्य या समाप्त। कृपया फिर रजिस्टर करें।",
    "hero.l1": "अपनी",
    "hero.l2": "तायक्वोंडो",
    "hero.l3": "प्रतियोगिताएँ प्रबंधित करें",
    "hero.sub": "इवेंट, एथलीट, पूल, रिंग और लाइव स्कोरबोर्ड — सब एक वेब प्लेटफ़ॉर्म पर।",
    "register.title": "खाता बनाएं",
    "register.name": "नाम",
    "register.cta": "रजिस्टर करें और 100 टोकन पाएं",
    "register.creating": "बनाया जा रहा है…",
    "register.haveAccount": "पहले से खाता है?",
    "register.login": "लॉग इन",
    "dash.events": "आपके इवेंट",
    "dash.eventsSub": "अपनी प्रतियोगिताएँ बनाएं और प्रबंधित करें।",
    "dash.newEvent": "नया इवेंट",
    "dash.eventName": "इवेंट का नाम",
    "dash.type": "प्रकार",
    "dash.date": "तारीख",
    "dash.deleteTitle": "इवेंट हटाएं",
    "dash.deleteWarn": "क्या आप वाकई यह इवेंट हटाना चाहते हैं? यह क्रिया अपरिवर्तनीय है और एथलीट, पूल, रिंग और मुकाबले भी हटा देती है।\nपुष्टि के लिए नीचे इवेंट का नाम लिखें।",
    "dash.clickToCopy": "कॉपी करने के लिए क्लिक करें",
    "dash.deleteCta": "स्थायी रूप से हटाएं",
    "dash.cancel": "रद्द करें",
    "ath.edit": "एथलीट संपादित करें",
    "ath.updated": "एथलीट अपडेट हुआ",
    "ath.lockedDiscipline": "अनुशासन इवेंट प्रकार से तय होता है।",
    "common.delete": "हटाएं",
    "dash.create": "इवेंट बनाएं",
    "dash.empty": "कोई इवेंट नहीं। शुरू करने के लिए एक बनाएं।",
    "dash.token": "टोकन",
    "banner.tokensZero": "टोकन समाप्त। जारी रखने के लिए रिचार्ज करें।",
    "banner.tokensZeroCta": "रिचार्ज के लिए यहां क्लिक करें",
    "dash.namePlaceholder": "जैसे सिटी ट्रॉफी 2026",
    "dash.confirmDelete": "यह इवेंट और इसका सारा डेटा हटाएं?",
    "dash.deleted": "इवेंट हटाया गया",
    "dash.created": "इवेंट बनाया गया",
    "dash.enterName": "एक नाम दर्ज करें",
    "type.combat": "क्योरुगी",
    "type.poomsae": "पूमसे",
    "type.mixed": "मिश्रित",
    "type.poomsaeForms": "पूमसे (फ़ॉर्म)",
    "ev.tabAthletes": "एथलीट",
    "ev.tabPools": "पूल और मुकाबले",
    "ev.tabRings": "रिंग",
    "ev.tabSettings": "सेटिंग्स",
    "common.loading": "लोड हो रहा है…",
    "ath.title": "एथलीट",
    "ath.templateCsv": "टेम्पलेट डाउनलोड (CSV)",
    "ath.import": "एथलीट आयात करें (CSV)",
    "ath.exportCsv": "एथलीट डाउनलोड (CSV)",
    "ath.add": "जोड़ें",
    "ath.new": "नया एथलीट",
    "ath.firstName": "पहला नाम",
    "ath.lastName": "उपनाम",
    "ath.birth": "जन्म तिथि",
    "ath.weight": "वज़न (किग्रा)",
    "ath.belt": "बेल्ट",
    "ath.height": "ऊंचाई (सेमी)",
    "ath.disciplines": "अनुशासन",
    "ath.save": "एथलीट सहेजें",
    "ath.colName": "उपनाम नाम",
    "ath.colBirth": "जन्म",
    "ath.colWeight": "वज़न",
    "ath.colBelt": "बेल्ट",
    "ath.colDisc": "अनुशासन",
    "ath.empty": "कोई एथलीट नहीं। जोड़ें या CSV/Excel से आयात करें।",
    "ath.reqNames": "पहला नाम और उपनाम आवश्यक",
    "ath.added": "एथलीट जोड़ा गया",
    "ath.imported": "{n} एथलीट आयात किए गए",
    "pool.title": "पूल",
    "pool.aiSuggest": "AI से सुझाव",
    "pool.aiWorking": "AI काम कर रहा है…",
    "pool.autoGen": "स्वतः जनरेट करें",
    "pool.autoTitle": "पूल स्वतः जनरेट करें",
    "pool.autoDesc": "तायक्वोंडो नियमों के अनुसार आयु वर्ग, बेल्ट और वज़न से एथलीटों को समूहित करता है।",
    "pool.method": "विधि",
    "pool.methodLocal": "स्थानीय (हमेशा उपलब्ध)",
    "pool.methodAi": "AI (अनुशंसित, नेटवर्क आवश्यक)",
    "pool.minSize": "न्यूनतम एथलीट/पूल",
    "pool.maxSize": "अधिकतम एथलीट/पूल",
    "pool.weightTol": "वज़न सहनशीलता (शरीर वज़न का %)",
    "pool.weightTolShort": "वज़न सहन. %",
    "pool.ageTolShort": "आयु सहन. %",
    "pool.heightTolShort": "ऊंचाई सहन. %",
    "pool.beltTolShort": "बेल्ट सहन. %",
    "pool.mixedPools": "मिश्रित पूल (सक्रिय होने पर मिश्रित)",
    "pool.tolHint": "100% का अर्थ है यह पैरामीटर अनदेखा किया जाता है।",
    "pool.replace": "मौजूदा पूल बदलें",
    "pool.generate": "पूल जनरेट करें",
    "pool.generating": "जनरेट हो रहा है…",
    "pool.autoCreated": "{n} पूल जनरेट हुए",
    "pool.aiFallback": "AI अनुपलब्ध: स्थानीय इंजन उपयोग किया ({n} पूल)",
    "pool.overrideTitle": "पूल सेटिंग्स",
    "pool.overrideDesc": "केवल इस पूल के लिए इवेंट सेटिंग्स को बदलें (जैसे बच्चों हेतु छोटे राउंड)।",
    "pool.overrideHint": "परिवर्तन लागू करने के लिए पूल के मुकाबले फिर जनरेट करें।",
    "pool.overrideActive": "कस्टम",
    "pool.overrideSaved": "पूल सेटिंग्स सहेजी गईं",
    "pool.overrideReset": "इवेंट पर रीसेट करें",
    "rc.offline": "ऑफ़लाइन",
    "rc.clearJudges": "जज हटाएं",
    "rc.clearJudgesConfirm": "इस रिंग से सभी जजों को हटाएं?",
    "rc.judgesCleared": "जज हटाए गए",
    "rc.resetJudges": "जज रीसेट करें",
    "rc.resetConfirm": "जजों की स्क्रीन रीसेट करें? उनकी चल रही स्कोरिंग हट जाएगी।",
    "rc.judgesReset": "जजों की स्क्रीन रीसेट हुई",
    "ath.sex": "लिंग",
    "ath.female": "महिला",
    "ath.male": "पुरुष",
    "ath.noSex": "अनिर्दिष्ट",
    "pool.renamePrompt": "पूल का नाम (आप नोट जोड़ सकते हैं, जैसे 'पूल 1, कैडेट'):",
    "j.leave": "छोड़ें",
    "j.add": "जोड़ें",
    "ring.accessQr": "स्टेशन एक्सेस",
    "ring.scanStation": "इस रिंग को खोलने के लिए टैबलेट/फ़ोन से QR स्कैन करें, या लिंक कॉपी करें (PC पर भी सुविधाजनक)।",
    "ring.quickLink": "क्विक लिंक कॉपी करें (ऑटो-लॉगिन)",
    "ring.secureLink": "सुरक्षित लिंक कॉपी करें (पासवर्ड मांगेगा)",
    "err.generic": "कुछ गड़बड़ हुई। कृपया फिर प्रयास करें।",
    "err.token_expired": "सत्र समाप्त। कृपया फिर लॉग इन करें।",
    "err.invalid_token": "अमान्य टोकन।",
    "err.not_authenticated": "प्रमाणित नहीं।",
    "err.user_not_found": "उपयोगकर्ता नहीं मिला।",
    "err.event_not_found": "इवेंट नहीं मिला।",
    "err.email_taken": "ईमेल पहले से पंजीकृत।",
    "err.invalid_credentials": "अमान्य क्रेडेंशियल।",
    "err.ring_password_wrong": "रिंग पासवर्ड गलत।",
    "err.ring_not_found": "रिंग नहीं मिली।",
    "err.athlete_not_found": "एथलीट नहीं मिला।",
    "err.file_read": "फ़ाइल पढ़ी नहीं जा सकी। प्रारूप जांचें।",
    "err.pool_not_found": "पूल नहीं मिला।",
    "err.tiebreak_only_score": "टाई-ब्रेक केवल स्कोर-आधारित पूमसे पूल के लिए उपलब्ध है।",
    "err.tiebreak_need_two": "टाई-ब्रेक के लिए कम से कम दो एथलीट चाहिए।",
    "err.pool_not_found_event": "इस इवेंट में पूल नहीं मिला।",
    "err.no_athletes_discipline": "इस अनुशासन के लिए कोई एथलीट नहीं।",
    "err.match_not_found": "मुकाबला नहीं मिला।",
    "err.access_denied": "पहुँच अस्वीकृत।",
    "err.judges_not_ready": "जज तैयार नहीं ({n})।",
    "err.tokens_exhausted": "टोकन समाप्त। जारी रखने के लिए रिचार्ज करें।",
    "err.unknown_action": "अज्ञात क्रिया।",
    "err.invalid_judge_token": "अमान्य जज टोकन।",
    "err.invalid_package": "अमान्य पैकेज।",
    "err.price_not_found": "कीमत नहीं मिली।",
    "err.transaction_not_found": "लेनदेन नहीं मिला।",
    "err.invalid_signature": "अमान्य हस्ताक्षर।",
    "pool.new": "नया पूल",
    "pool.unassigned": "असाइन नहीं",
    "pool.athletes": "{n} एथलीट",
    "pool.allAssigned": "सभी असाइन किए गए।",
    "pool.dragHere": "एथलीटों को यहां खींचें।",
    "pool.genMatches": "मुकाबले जनरेट करें",
    "pool.matches": "{n} मुकाबले",
    "pool.needMore": "और एथलीट चाहिए",
    "pool.aiCreated": "AI: {n} पूल बनाए",
    "pool.moveError": "स्थानांतरण त्रुटि",
    "pool.matchesGenerated": "{n} मुकाबले जनरेट हुए",
    "bracket.single_elim": "सिंगल एलिमिनेशन",
    "bracket.round_robin": "राउंड रॉबिन",
    "bracket.group_elim": "ग्रुप + एलिमिनेशन",
    "bracket.score": "स्कोर द्वारा",
    "ring.title": "रिंग और असाइनमेंट",
    "ring.name": "रिंग का नाम",
    "ring.number": "नंबर",
    "ring.discipline": "अनुशासन",
    "ring.create": "रिंग बनाएं",
    "ring.created": "रिंग बनाई गई",
    "ring.none": "कोई रिंग नहीं। मुकाबले असाइन करने के लिए एक बनाएं।",
    "ring.assigned": "{n} मुकाबले असाइन किए",
    "ring.eventId": "इवेंट ID",
    "ring.ringId": "रिंग ID",
    "ring.password": "पासवर्ड",
    "ring.assignPool": "पूल असाइन करें…",
    "ring.assign": "असाइन करें",
    "ring.openStation": "रिंग खोलें",
    "ring.selectPool": "एक पूल चुनें",
    "ring.genFirst": "पहले मुकाबले जनरेट करें",
    "ring.copied": "कॉपी हुआ",
    "ring.assignedToast": "{n} मुकाबले {ring} को असाइन किए",
    "ring.assignedPools": "असाइन किए गए पूल (क्रम में)",
    "ring.removePool": "रिंग से पूल हटाएं",
    "ring.printRing": "रिंग शीट प्रिंट करें",
    "ring.poolRemoved": "पूल रिंग से हटाया गया",
    "ring.allPoolsAssigned": "सभी पूल पहले से असाइन हैं",
    "filter.both": "क्योरुगी और पूमसे",
    "filter.combat": "क्योरुगी",
    "filter.poomsae": "पूमसे",
    "set.title": "इवेंट सेटिंग्स",
    "set.sub": "सभी मुकाबलों के लिए डिफ़ॉल्ट; आप इन्हें प्रति मुकाबला भी बदल सकते हैं।",
    "set.combat": "क्योरुगी",
    "set.rounds": "राउंड की संख्या",
    "set.roundDur": "राउंड अवधि (s)",
    "set.break": "विराम (s)",
    "set.koDiff": "तकनीकी KO अंक अंतर",
    "set.consensusWindow": "सहमति विंडो (s)",
    "set.consensusHint": "वे सेकंड जिनमें अंक देने हेतु अधिकांश जजों को सहमत होना चाहिए (0.2–2.0)।",
    "set.judges": "जजों की संख्या",
    "set.poomsae": "पूमसे",
    "set.forms": "प्रति एथलीट फ़ॉर्म",
    "set.ringAccess": "रिंग एक्सेस",
    "set.ringPw": "रिंग पासवर्ड (साझा)",
    "set.ringPwHint": "रिंग कंप्यूटर इसे इवेंट से जुड़ने के लिए उपयोग करते हैं।",
    "set.save": "सेटिंग्स सहेजें",
    "set.saving": "सहेजा जा रहा है…",
    "set.saved": "सेटिंग्स सहेजी गईं",
    "set.tokensTitle": "टोकन",
    "set.tokensPoomsae": "प्रत्येक पूमसे मूल्यांकन के लिए एक टोकन आवश्यक है।",
    "set.tokensCombat": "प्रत्येक क्योरुगी मुकाबले (किसी भी राउंड संख्या) के लिए दो टोकन आवश्यक हैं।",
    "set.tokensCheck": "सुनिश्चित करें कि आपके पास इवेंट चलाने हेतु पर्याप्त टोकन हैं।",
    "set.tokensReload": "टोकन रिचार्ज करें",
    "rl.title": "रिंग लॉगिन",
    "rl.back": "लॉगिन पर लौटें",
    "rl.sub": "मुकाबले प्रबंधित करने हेतु रिंग स्टेशन के रूप में लॉग इन करें।",
    "rl.connect": "रिंग कनेक्ट करें",
    "rl.connecting": "कनेक्ट हो रहा है…",
    "rl.connected": "कनेक्ट हुआ: {name}",
    "rc.queue": "कतार",
    "rc.judges": "जज",
    "rc.monitor": "मॉनिटर",
    "rc.incontri": "मुकाबले",
    "rc.noneAssigned": "कोई मुकाबला असाइन नहीं।",
    "rc.colJudge": "जज",
    "rc.colTech": "तकनीकी मूल्यांकन",
    "rc.colBalance": "संतुलन",
    "rc.colRhythm": "लय",
    "rc.colPower": "शक्ति",
    "rc.colTotal": "कुल",
    "rc.colAvg": "औसत",
    "rc.noVotesYet": "जजों के मतों की प्रतीक्षा…",
    "rc.selectMatch": "कतार से एक मुकाबला चुनें।",
    "rc.round": "राउंड",
    "rc.break": "विराम",
    "rc.start": "शुरू",
    "rc.pause": "रोकें",
    "rc.reset": "रीसेट",
    "rc.resetMatch": "रीसेट",
    "rc.resetMatchConfirm": "पुनः मुकाबला? परिणाम हट जाएगा और पुनः शुरू पर फिर 2 टोकन लगेंगे।",
    "rc.resetMatchHint": "पुनः शुरू करने पर फिर 2 टोकन खर्च होंगे।",
    "rc.matchReset": "मुकाबला रीसेट हुआ",
    "err.match_locked": "परिणाम लॉक: पुनः मुकाबले हेतु रीसेट उपयोग करें।",
    "rc.roundPlus": "राउंड +",
    "rc.roundExtraHint": "अतिरिक्त राउंड केवल निर्धारित राउंड के अंत में बराबरी पर उपलब्ध।",
    "err.round_not_tied": "अतिरिक्त राउंड केवल बराबरी पर अनुमत।",
    "rc.medical": "मेडिकल टाइमआउट",
    "rc.soundOn": "ध्वनि चालू (राउंड और विराम समाप्ति)",
    "rc.soundOff": "ध्वनि बंद",
    "rc.waitingJudges": "जजों के तैयार होने की प्रतीक्षा ({r}/{n})",
    "rc.winner": "विजेता: {name}",
    "rc.performing": "प्रदर्शन जारी",
    "rc.tie": "बराबरी",
    "rc.tieHint": "औसत बराबर: टाई-ब्रेक पर विचार करें।",
    "rc.koTitle": "तकनीकी KO",
    "rc.koMsg": "अंक अंतर पूरा हुआ। {name} को तकनीकी KO से विजेता घोषित करें?",
    "rc.koConfirm": "KO पुष्टि करें",
    "rc.koContinue": "मुकाबला जारी रखें",
    "mon.performing": "प्रदर्शन जारी",
    "res.reshuffle": "पुनः ड्रॉ",
    "pool.drawPreview": "मुकाबले पूर्वावलोकन",
    "pool.downloadPdf": "PDF डाउनलोड",
    "common.pdf": "PDF",
    "pool.execOrder": "प्रदर्शन क्रम",
    "pool.bye": "(बाय)",
    "res.reshuffleConfirm": "नई यादृच्छिक जोड़ी के साथ ड्रॉ पुनः जनरेट करें?",
    "res.reshuffled": "नया ड्रॉ पूर्ण",
    "res.swapHint": "स्थान बदलने हेतु पहले राउंड के दो एथलीटों पर क्लिक करें।",
    "res.tiebreak": "टाई-ब्रेक",
    "res.tiebreakBtn": "टाई-ब्रेक बनाएं",
    "res.tiebreakRegen": "टाई-ब्रेक पुनः जनरेट करें",
    "res.tiebreakCreated": "टाई-ब्रेक बना: इसे रिंग पर चलाएं",
    "res.tiebreakPending": "टाई-ब्रेक जारी",
    "rc.winnerDecreed": "विजेता घोषित",
    "rc.point": "अंक",
    "rc.wins": "जीत",
    "rc.warnLight": "मामूली चेतावनी:",
    "rc.warnSevere": "गंभीर चेतावनी:",
    "rc.judgesQr": "QR से जज",
    "rc.ready": "तैयार",
    "rc.noJudges": "कोई जज कनेक्ट नहीं।",
    "rc.requireReady": "जजों की तैयारी आवश्यक करें",
    "rc.startPerf": "प्रदर्शन शुरू करें",
    "rc.waitingReady": "जजों के तैयार होने की प्रतीक्षा",
    "rc.startConsumes": "शुरू करने पर 1 टोकन लगता है और जज स्कोरिंग अनलॉक होती है।",
    "rc.form": "पूमसे",
    "rc.avgAuto": "जैसे ही सभी जज सक्रिय फ़ॉर्म हेतु सबमिट करते हैं, जजों का औसत स्वतः गणना होता है।",
    "rc.avgTotal": "कुल औसत",
    "rc.confirmPerf": "पुष्टि करें और प्रदर्शन बंद करें",
    "rc.confirmPerformance": "प्रदर्शन की पुष्टि करें",
    "rc.perfConfirmed": "प्रदर्शन पुष्ट",
    "rc.cancelPerformance": "प्रदर्शन रद्द करें",
    "rc.cancelPerfConfirm": "प्रदर्शन रद्द करें? अंक रीसेट होंगे और जज फिर मत देंगे।",
    "rc.removeJudge": "जज हटाएं",
    "rc.removeJudgeConfirm": "इस जज को रिंग से हटाएं?",
    "rc.judgeRemoved": "जज हटाया गया",
    "j.access": "जज लॉगिन",
    "j.yourName": "आपका नाम",
    "j.ready": "तैयार",
    "j.waitingMatch": "रिंग द्वारा मुकाबला चुने जाने की प्रतीक्षा…",
    "j.assignPoints": "अंक दें — फ़ोन क्षैतिज पकड़ें",
    "j.technical": "तकनीकी अंक",
    "j.form": "पूमसे",
    "j.errLight": "मामूली त्रुटि",
    "j.errSevere": "गंभीर त्रुटि",
    "j.energy": "ऊर्जा",
    "j.balance": "संतुलन",
    "j.rhythm": "लय",
    "j.total": "कुल",
    "j.send": "अंक भेजें",
    "j.readyFirst": "पहले अपनी तैयारी की पुष्टि करें",
    "j.sent": "भेजा गया",
    "j.voteSent": "अंक भेजा गया: {v}",
    "mon.waiting": "मुकाबले की प्रतीक्षा",
    "mon.warnLight": "मामूली चेत.",
    "mon.warnSevere": "गंभीर चेत.",
    "mon.round": "राउंड",
    "mon.break": "विराम",
    "mon.medical": "मेडिकल",
    "mon.winner": "विजेता",
    "mon.form": "पूमसे",
    "mon.avg": "औसत",
    "bill.title": "टोकन रिचार्ज",
    "bill.sub": "प्रत्येक क्योरुगी मुकाबले हेतु 2 टोकन, प्रत्येक पूमसे प्रदर्शन हेतु 1 टोकन।",
    "bill.custom": "कस्टम मात्रा",
    "bill.token": "टोकन",
    "bill.perToken": "/ टोकन",
    "bill.buy": "खरीदें",
    "bill.redirecting": "पुनर्निर्देशित हो रहा है…",
    "bill.checkoutTitle": "भुगतान पूरा करें",
    "bill.checkoutSub": "टोकन · €",
    "bill.loading": "भुगतान लोड हो रहा है…",
    "bill.best": "सर्वोत्तम मूल्य",
    "bill.secure": "Stripe के माध्यम से सुरक्षित भुगतान।",
    "bill.secureLive": "Stripe और PayPal के माध्यम से सुरक्षित भुगतान।",
    "bill.orPaypal": "या PayPal से भुगतान करें",
    "bill.paypalSuccess": "PayPal भुगतान पूर्ण, टोकन जमा हुए!",
    "bill.paypalError": "PayPal भुगतान विफल। कृपया फिर प्रयास करें।",
    "pay.checking": "भुगतान की पुष्टि हो रही है…",
    "pay.success": "भुगतान सफल",
    "pay.added": "आपके खाते में {n} टोकन जोड़े गए।",
    "pay.backDash": "डैशबोर्ड पर लौटें",
    "pay.pending": "भुगतान प्रक्रिया में। टोकन शीघ्र दिखेंगे।",
    "pay.dashboard": "डैशबोर्ड",
    "pay.error": "कुछ गड़बड़ हुई",
    "pay.retry": "पुनः प्रयास",
    "pay.cancelled": "भुगतान रद्द",
    "pay.backPackages": "पैकेज पर लौटें",
    "ev.tabResults": "परिणाम",
    "res.champion": "चैंपियन",
    "res.title": "परिणाम",
    "res.export": "परिणाम डाउनलोड",
    "res.exportTitle": "टूर्नामेंट परिणाम",
    "res.standings": "स्टैंडिंग",
    "res.wins": "जीत",
    "res.noData": "कोई मुकाबला जनरेट नहीं। जनरेट करने हेतु पूल पर जाएं।",
    "res.round": "राउंड",
    "res.pending": "लंबित",
    "res.avg": "औसत",
    "res.tbd": "तय होना बाकी",
    "res.bye": "बाय",
    "admin.link": "KIHAP एडमिन",
    "admin.back": "डैशबोर्ड पर लौटें",
    "admin.createTitle": "खाता बनाएं",
    "admin.email": "ईमेल",
    "admin.name": "नाम",
    "admin.tokens": "टोकन",
    "admin.password": "पासवर्ड",
    "admin.pwManual": "पासवर्ड मैन्युअल सेट करें",
    "admin.pwAutoHint": "स्वतः जनरेटेड",
    "admin.create": "खाता बनाएं",
    "admin.created": "खाता बनाया गया",
    "admin.genPw": "जनरेटेड पासवर्ड (अभी कॉपी करें):",
    "admin.copy": "कॉपी",
    "admin.copied": "कॉपी हुआ",
    "admin.usersTitle": "उपयोगकर्ता",
    "admin.search": "ईमेल या नाम से खोजें",
    "admin.role": "भूमिका",
    "admin.balance": "टोकन",
    "admin.save": "सहेजें",
    "admin.updated": "टोकन अपडेट हुए",
    "admin.delete": "खाता हटाएं",
    "admin.deleted": "खाता हटाया गया",
    "admin.confirmDelete": "खाता {email} स्थायी रूप से हटाएं?",
    "err.cannot_delete_admin": "आप एडमिन खाता नहीं हटा सकते",
    "admin.noUsers": "कोई उपयोगकर्ता नहीं",
    "admin.error": "क्रिया विफल",
    "acct.title": "सेटिंग्स",
    "acct.account": "आपका खाता",
    "acct.username": "उपयोगकर्ता नाम",
    "acct.usernameHint": "रजिस्ट्रेशन में चुना नाम: यही ऐप में दिखता है।",
    "acct.email": "ईमेल",
    "acct.tokenCredit": "टोकन शेष",
    "acct.editName": "उपयोगकर्ता नाम संपादित करें",
    "acct.nameSaved": "नाम अपडेट हुआ",
    "err.name_taken": "उपयोगकर्ता नाम पहले से उपयोग में।",
    "err.name_required": "उपयोगकर्ता नाम दर्ज करें।",
    "acct.pwEncrypted": "पासवर्ड एन्क्रिप्टेड है और सुरक्षा हेतु नहीं दिखाया जा सकता। आप नीचे बदल सकते हैं।",
    "acct.changePw": "पासवर्ड बदलें",
    "acct.oldPw": "वर्तमान पासवर्ड",
    "acct.newPw": "नया पासवर्ड",
    "acct.confirmPw": "नया पासवर्ड पुष्टि करें",
    "acct.pwMismatch": "पासवर्ड मेल नहीं खाते।",
    "acct.pwChanged": "पासवर्ड अपडेट हुआ",
    "acct.recovery": "रिकवरी ईमेल",
    "acct.recoveryHint": "पहुँच पुनःप्राप्ति हेतु: आपको उपयोगकर्ता नाम और पासवर्ड रीसेट लिंक मिलेगा।",
    "acct.recoveryEmail": "रिकवरी ईमेल",
    "acct.recoveryEdit": "रिकवरी ईमेल संपादित करें",
    "acct.recoverySaved": "रिकवरी ईमेल सहेजा गया",
    "acct.antiPhish": "एंटी-फ़िशिंग कोड",
    "acct.antiPhishHint": "हर KIHAP ईमेल में मौजूद कोड: अगर किसी ईमेल में न हो, तो वह फ़िशिंग है।",
    "acct.antiPhishEdit": "एंटी-फ़िशिंग कोड संपादित करें",
    "acct.antiPhishSaved": "एंटी-फ़िशिंग कोड सहेजा गया",
    "acct.movements": "टोकन लेनदेन",
    "acct.noMovements": "अभी कोई खरीद नहीं",
    "acct.date": "तारीख",
    "acct.tokens": "टोकन",
    "acct.amount": "राशि",
    "acct.method": "विधि",
    "acct.dangerZone": "खतरनाक क्षेत्र",
    "acct.deleteAccount": "खाता हटाएं",
    "acct.deleteWarnShort": "हटाने से आपके बनाए सभी इवेंट, एथलीट जानकारी और खरीदे गए टोकन स्थायी रूप से खो जाएंगे।",
    "acct.deleteTitle": "खाता हटाना",
    "acct.deleteWarn": "हटाने से आपके बनाए सभी इवेंट, एथलीट जानकारी और खरीदे गए टोकन स्थायी रूप से खो जाएंगे। खाता स्थायी रूप से हटाने हेतु नीचे अपने खाते का नाम लिखें और पुष्टि करें।",
    "acct.deleteCta": "स्थायी रूप से हटाएं",
    "acct.deleteSuccess": "खाता हटाया गया",
    "acct.deleteAdminNote": "एडमिन खाते हटाए नहीं जा सकते।",
    "acct.error": "क्रिया विफल",
    "rpw.title": "पासवर्ड रीसेट करें",
    "rpw.submit": "रीसेट",
    "rpw.done": "पासवर्ड रीसेट हुआ। अब आप लॉग इन कर सकते हैं।",
    "rpw.invalid": "लिंक अमान्य या समाप्त।",
    "login.forgot": "पासवर्ड भूल गए?",
    "login.forgotPrompt": "अपना रिकवरी ईमेल दर्ज करें (सेटिंग्स में सेट किया हुआ):",
    "login.forgotSent": "यदि रिकवरी ईमेल मौजूद है, तो हमने निर्देश भेज दिए हैं।",
    "err.old_password_wrong": "वर्तमान पासवर्ड गलत है",
    "err.password_short": "पासवर्ड कम से कम 6 अक्षरों का होना चाहिए",
    "err.reset_invalid": "रीसेट लिंक अमान्य या समाप्त",
    "err.email_failed": "ईमेल भेजने में विफल",
    "err.admin_only": "केवल एडमिन",
    "err.email_required": "मान्य ईमेल आवश्यक",
    "err.no_change": "कोई परिवर्तन नहीं",
    "csv.firstName": "पहला नाम", "csv.lastName": "उपनाम", "csv.birth": "जन्म तिथि", "csv.weight": "वज़न", "csv.belt": "बेल्ट", "csv.school": "TKD स्कूल", "csv.height": "ऊंचाई", "csv.sex": "लिंग", "csv.compType": "प्रतियोगिता प्रकार",
    "dash.duration": "अवधि (दिन)", "dash.days": "दिन", "status.programmato": "निर्धारित", "status.in_corso": "चल रहा", "status.concluso": "समाप्त", "status.non_svolto": "आयोजित नहीं",
    "set.tokensOwner": "टोकन केवल इवेंट के स्वामी के बैलेंस से काटे जाते हैं।", "collab.title": "सहयोगी प्रबंधन", "collab.desc": "केवल स्वामी ही भूमिकाएँ सौंप या हटा सकता है।", "collab.roleOwner": "स्वामी", "collab.roleCo": "सह-आयोजक", "collab.roleReg": "पंजीकरण कर्मी", "collab.roleObs": "पर्यवेक्षक", "collab.email": "सहयोगी का KIHAP ईमेल", "collab.add": "निमंत्रण बनाएं", "collab.linkCreated": "निमंत्रण लिंक बनाया और कॉपी किया गया — सहयोगी को भेजें।", "collab.none": "कोई सहयोगी नहीं।", "collab.confirmRemoveTitle": "सहयोगी हटाएँ?", "collab.confirmRemoveDesc": "{name} तुरंत इवेंट तक पहुँच खो देगा। कोई भी लंबित निमंत्रण लिंक अमान्य हो जाएगा। आप बाद में फिर से आमंत्रित कर सकते हैं।", "collab.confirmRemoveBtn": "हटाएँ", "forgot.title": "पहुँच पुनर्प्राप्त करें", "forgot.desc": "अपने खाते से जुड़ा ईमेल पता दर्ज करें और हम आपको खाते तक पहुँचने के लिए एक ईमेल भेजेंगे।", "forgot.cta": "पुनर्प्राप्ति लिंक भेजें", "forgot.back": "लॉगिन पर वापस जाएँ", "forgot.sentTitle": "अपना ईमेल जाँचें", "forgot.sentMsg": "यदि इस पते से कोई खाता मौजूद है, तो हमने आपको लॉगिन करने के लिए एक ईमेल भेजा है:", "club.title": "क्लब रैंकिंग", "club.desc": "चुनें कि क्लबों को कैसे रैंक किया जाए।", "club.method": "रैंकिंग विधि", "club.methodMedals": "स्वर्ण पदकों के अनुसार (ओलंपिक शैली)", "club.methodPoints": "अंकों के अनुसार", "club.goldPts": "प्रति स्वर्ण अंक", "club.silverPts": "प्रति रजत अंक", "club.bronzePts": "प्रति कांस्य अंक", "club.doubleBronze": "डबल कांस्य", "club.doubleBronzeHint": "यदि चालू है, तो तीसरे और चौथे दोनों स्थानों को कांस्य दिया जाता है (दोनों पदक तालिका में गिने जाते हैं)।", "ev.tabOffline": "ऑफ़लाइन मोड", "off.title": "ऑफ़लाइन / LAN मोड", "off.desc": "अपने PC पर चलाने के लिए KIHAP Server Tournament डाउनलोड करें। जज और रिंग राउटर के लोकल WiFi से जुड़ते हैं, इंटरनेट की ज़रूरत नहीं।", "off.estimate": "इस इवेंट के लिए अनुमानित टोकन", "off.breakdown": "{combat} मुकाबले × 2 टोकन + {poomsae} पूमसे मूल्यांकन", "off.tiebreak": "इवेंट के दौरान टाई की स्थिति संभालने के लिए अतिरिक्त मूल्यांकन ज़रूरी हो सकते हैं। इन मामलों के लिए 15 अतिरिक्त टोकन रखना सुनिश्चित करें।", "off.balance": "आपका वर्तमान बैलेंस", "off.deductNote": "सर्वर डाउनलोड करने पर आपके बैलेंस से {n} टोकन काटे जाएंगे और इस इवेंट के पैकेज में लोड किए जाएंगे।", "off.aiOff": "लोकल LAN मोड में AI सुविधाएँ बंद रहती हैं।", "off.download": "KIHAP Server Tournament डाउनलोड करें", "off.downloading": "पैकेज तैयार हो रहा है...", "off.ready": "डाउनलोड शुरू हुआ।", "off.notEnough": "सर्वर डाउनलोड करने के लिए पर्याप्त टोकन नहीं हैं।", "off.ownerOnly": "केवल इवेंट का स्वामी ही सर्वर डाउनलोड कर सकता है।", "offtok.warn": "ध्यान दें: {n} टोकन शेष", "offtok.low": "केवल {n} टोकन बचे हैं!", "offtok.emptyTitle": "टोकन समाप्त", "offtok.emptyMsg": "मूल्यांकन रोक दिए गए हैं। जारी रखने के लिए, PC को इंटरनेट से कनेक्ट करें, और टोकन खरीदें और इवेंट सर्वर फिर से डाउनलोड करें।", "offtok.dismiss": "ब्राउज़ करते रहें", "offtok.suspended": "टोकन समाप्त — नए मूल्यांकन रोके गए", "srv.scan": "कनेक्ट करने के लिए स्कैन करें", "srv.judgesScan": "जज: अपना रिंग स्कैन करें", "srv.offlineOnly": "यह पेज केवल ऑफ़लाइन (LAN) मोड में उपलब्ध है।", "srv.noRings": "कोई रिंग कॉन्फ़िगर नहीं", "res.clubs": "क्लब", "clubres.club": "क्लब", "clubres.athletes": "एथलीट", "clubres.gold": "स्वर्ण", "clubres.silver": "रजत", "clubres.bronze": "कांस्य", "clubres.points": "अंक", "clubres.rank": "रैंक", "clubres.noClub": "कोई क्लब नहीं", "invite.title": "सहयोग निमंत्रण", "invite.accept": "निमंत्रण स्वीकारें", "invite.wrongEmail": "यह निमंत्रण किसी अन्य ईमेल खाते के लिए है। आमंत्रित ईमेल से लॉगिन करें।", "invite.accepted": "निमंत्रण स्वीकृत!", "err.invite_wrong_email": "यह निमंत्रण किसी अन्य ईमेल खाते के लिए है।",
  },
};
